webpackJsonp([2,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(159);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(328);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _vueRouter = __webpack_require__(329);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _routes = __webpack_require__(163);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _store = __webpack_require__(164);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _App = __webpack_require__(274);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueResource2.default);
	_vue2.default.http.options.emulateJSON = true;
	
	_vue2.default.use(_vueRouter2.default);
	
	var router = new _vueRouter2.default({
	  routes: _routes2.default,
	  mode: 'history',
	  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
	    return savedPosition || { x: 0, y: 0 };
	  }
	});
	
	if (window.localStorage) {
	  if (_store2.default.state.token_log !== window.localStorage.getItem('token_log')) {
	    _store2.default.commit('SET_TOKEN_LOG', window.localStorage.getItem('token_log'));
	  }
	  if (_store2.default.state.token_header !== window.localStorage.getItem('token_header')) {
	    _store2.default.commit('SET_TOKEN_HEADER', window.localStorage.getItem('token_header'));
	  }
	  if (_store2.default.state.role !== window.localStorage.getItem('role')) {
	    _store2.default.commit('SET_ROLE', window.localStorage.getItem('role'));
	  }
	}
	
	router.beforeEach(function (to, from, next) {
	  if (to.matched.some(function (record) {
	    return record.meta.requiresAuth;
	  }) && _store2.default.state.token_log === null) {
	    next('/login');
	  } else if (_store2.default.state.token_log !== null && to.path === '/login') {
	    next('/dashboard');
	  } else {
	    next();
	  }
	});
	
	window.baseUrl = 'https://services.agar.rs/';
	window.baseUrl2 = 'https://agar.rs';
	
	new _vue2.default({
	  el: '#app',
	  router: router,
	  store: _store2.default,
	  render: function render(h) {
	    return h(_App2.default);
	  }
	});
	
	__webpack_require__(200);
	__webpack_require__(18);
	__webpack_require__(161);
	__webpack_require__(162);

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Login = __webpack_require__(276);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _Dashboard = __webpack_require__(275);
	
	var _Dashboard2 = _interopRequireDefault(_Dashboard);
	
	var _Index = __webpack_require__(282);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _Admin = __webpack_require__(280);
	
	var _Admin2 = _interopRequireDefault(_Admin);
	
	var _History = __webpack_require__(281);
	
	var _History2 = _interopRequireDefault(_History);
	
	var _Data = __webpack_require__(288);
	
	var _Data2 = _interopRequireDefault(_Data);
	
	var _SQL = __webpack_require__(286);
	
	var _SQL2 = _interopRequireDefault(_SQL);
	
	var _dashboard = __webpack_require__(287);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _ = __webpack_require__(285);
	
	var _2 = _interopRequireDefault(_);
	
	var _Index3 = __webpack_require__(295);
	
	var _Index4 = _interopRequireDefault(_Index3);
	
	var _AllInfo = __webpack_require__(294);
	
	var _AllInfo2 = _interopRequireDefault(_AllInfo);
	
	var _facebook = __webpack_require__(296);
	
	var _facebook2 = _interopRequireDefault(_facebook);
	
	var _Index5 = __webpack_require__(289);
	
	var _Index6 = _interopRequireDefault(_Index5);
	
	var _Pending = __webpack_require__(290);
	
	var _Pending2 = _interopRequireDefault(_Pending);
	
	var _index = __webpack_require__(278);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _NonAnalytic = __webpack_require__(277);
	
	var _NonAnalytic2 = _interopRequireDefault(_NonAnalytic);
	
	var _Waiting = __webpack_require__(293);
	
	var _Waiting2 = _interopRequireDefault(_Waiting);
	
	var _Private = __webpack_require__(292);
	
	var _Private2 = _interopRequireDefault(_Private);
	
	var _PrivateWaiting = __webpack_require__(291);
	
	var _PrivateWaiting2 = _interopRequireDefault(_PrivateWaiting);
	
	var _Index7 = __webpack_require__(279);
	
	var _Index8 = _interopRequireDefault(_Index7);
	
	var _Index9 = __webpack_require__(283);
	
	var _Index10 = _interopRequireDefault(_Index9);
	
	var _Rewards = __webpack_require__(284);
	
	var _Rewards2 = _interopRequireDefault(_Rewards);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var routes = [{
	  path: '/login',
	  name: 'login',
	  component: _Login2.default,
	  beforeEnter: function beforeEnter(to, from, next) {
	    document.body.className = 'login-page';
	    next();
	  }
	}, {
	  path: '/',
	  component: _Dashboard2.default,
	  meta: { requiresAuth: true },
	  beforeEnter: function beforeEnter(to, from, next) {
	    document.body.className += ' skin-blue sidebar-mini';
	    next();
	  },
	  activate: function activate() {
	    this.$nextTick(function () {});
	  },
	  children: [{
	    path: '',
	    redirect: '/skins-managment'
	  }, {
	    path: '/chats',
	    name: 'chats',
	    component: _Index2.default
	  }, {
	    path: '/chats/history',
	    name: 'history',
	    component: _History2.default
	  }, {
	    path: '/servers-data',
	    name: 'serversData',
	    component: _Data2.default
	  }, {
	    path: '/users',
	    name: 'users',
	    component: _Index4.default
	  }, {
	    path: '/all-info',
	    name: 'allInfo',
	    component: _AllInfo2.default
	  }, {
	    path: '/analytic',
	    name: 'analytic',
	    component: _index2.default
	  }, {
	    path: '/block-analytics',
	    name: 'NonAnalytic',
	    component: _NonAnalytic2.default
	  }, {
	    path: '/facebook-switch',
	    name: 'fbusers',
	    component: _facebook2.default
	  }, {
	    path: '/skins',
	    name: 'skins',
	    component: _Index6.default
	  }, {
	    path: '/skins-managment',
	    name: 'waiting',
	    component: _Waiting2.default
	  }, {
	    path: '/private-skins',
	    name: 'private',
	    component: _Private2.default
	  }, {
	    path: '/ban',
	    name: 'Ban',
	    component: _Index8.default
	  }, {
	    path: '/coins',
	    name: 'Coins',
	    component: _Index10.default
	  }, {
	    path: '/private-skins-managment',
	    name: 'privateWaiting',
	    component: _PrivateWaiting2.default
	  }, {
	    path: '/pending-skins',
	    name: 'Pending',
	    component: _Pending2.default
	  }, {
	    path: '/dashboard',
	    name: 'dashboardHome',
	    component: _dashboard2.default
	  }, {
	    path: '/rewards',
	    name: 'Rewards',
	    component: _Rewards2.default
	  }, {
	    path: '/admin-chat',
	    name: 'Admin',
	    component: _Admin2.default
	  }, {
	    path: '/sql',
	    name: 'SQL',
	    component: _SQL2.default
	  }, {
	    path: '*',
	    name: '404',
	    component: _2.default
	  }]
	}, {
	  path: '*',
	  redirect: '/login'
	}];
	
	exports.default = routes;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(159);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(160);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _Form = __webpack_require__(166);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	window.Form = _Form2.default;
	
	_vue2.default.use(_vuex2.default);
	
	var state = {
	  token_log: null,
	  token_header: null,
	  nickname: null,
	  role: 0,
	  waitSkins: 0,
	  waitPrivateSkins: 0,
	  chat: {
	    messages: [],
	    users: [],
	    userName: ''
	  }
	};
	
	var mutations = {
	  SET_TOKEN_LOG: function SET_TOKEN_LOG(state, token) {
	    state.token_log = token;
	  },
	  SET_TOKEN_HEADER: function SET_TOKEN_HEADER(state, token) {
	    state.token_header = token;
	  },
	  SET_NAME: function SET_NAME(state, nickname) {
	    state.nickname = nickname;
	  },
	  SET_SKINS: function SET_SKINS(state, number) {
	    state.waitSkins = number;
	  },
	  SET_PRIVATE_SKINS: function SET_PRIVATE_SKINS(state, number) {
	    state.waitPrivateSkins = number;
	  },
	  SET_ROLE: function SET_ROLE(state, role) {
	    state.role = role;
	  },
	  INIT_MESSAGES: function INIT_MESSAGES(state, messages) {
	    state.chat.messages = messages;
	  },
	  INIT_USERS: function INIT_USERS(state, users) {
	    state.chat.users = users;
	  },
	  GET_MESSAGE: function GET_MESSAGE(state, message) {
	    state.chat.messages.push(message);
	  },
	  REMOVE_TOKEN: function REMOVE_TOKEN(state) {
	    state.token_log = null;
	    state.token_header = null;
	  }
	};
	
	exports.default = new _vuex2.default.Store({
	  state: state,
	  mutations: mutations
	});

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(197);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _classCallCheck2 = __webpack_require__(28);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(29);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Errors = function () {
	  function Errors() {
	    (0, _classCallCheck3.default)(this, Errors);
	
	    this.errors = {};
	  }
	
	  (0, _createClass3.default)(Errors, [{
	    key: "has",
	    value: function has(field) {
	      return this.errors.hasOwnProperty(field);
	    }
	  }, {
	    key: "any",
	    value: function any() {
	      return (0, _keys2.default)(this.errors).length > 0;
	    }
	  }, {
	    key: "get",
	    value: function get(field) {
	      if (this.errors[field]) {
	        return this.errors[field];
	      }
	    }
	  }, {
	    key: "record",
	    value: function record(errors) {
	      this.errors = errors;
	    }
	  }, {
	    key: "clear",
	    value: function clear(field) {
	      if (field) {
	        delete this.errors[field];
	
	        return;
	      }
	
	      this.errors = {};
	    }
	  }, {
	    key: "hideError",
	    value: function hideError(field) {
	      if (field) {
	        delete this.errors[field];
	
	        return;
	      }
	    }
	  }]);
	  return Errors;
	}();
	
	exports.default = Errors;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(198);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _classCallCheck2 = __webpack_require__(28);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(29);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _Errors = __webpack_require__(165);
	
	var _Errors2 = _interopRequireDefault(_Errors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Form = function () {
	  function Form(data) {
	    (0, _classCallCheck3.default)(this, Form);
	
	    this.originalData = data;
	
	    for (var field in data) {
	      this[field] = data[field];
	    }
	
	    this.errors = new _Errors2.default();
	  }
	
	  (0, _createClass3.default)(Form, [{
	    key: 'data',
	    value: function data() {
	      var data = {};
	
	      for (var property in this.originalData) {
	        data[property] = this[property];
	      }
	
	      return data;
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      for (var field in this.originalData) {
	        this[field] = '';
	      }
	
	      this.errors.clear();
	    }
	  }, {
	    key: 'post',
	    value: function post(url, data) {
	      var ct = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	      return this.submit('post', url, data, ct);
	    }
	  }, {
	    key: 'put',
	    value: function put(url) {
	      return this.submit('put', url);
	    }
	  }, {
	    key: 'patch',
	    value: function patch(url) {
	      return this.submit('patch', url);
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(url) {
	      return this.submit('delete', url);
	    }
	  }, {
	    key: 'submit',
	    value: function submit(requestType, url) {
	      var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.data();
	      var ct = arguments[3];
	
	      var conTy, encTy, procesData;
	      if (ct === 1) {
	        procesData = false;
	        conTy = false;
	        encTy = 'multipart/form-data';
	      } else {
	        conTy = 'application/x-www-form-urlencoded';
	        encTy = false;
	        procesData = true;
	      }
	
	      return new _promise2.default(function (resolve, reject) {
	        $.ajax({
	          url: url,
	          enctype: encTy,
	          crossDomain: true,
	          contentType: conTy,
	          type: requestType,
	          dataType: 'json',
	          data: data,
	          processData: procesData,
	          success: function success(response) {
	            resolve(response);
	          },
	          error: function error(jqXHR, textStatus, errorThrown) {
	            reject(textStatus);
	          }
	        });
	      });
	    }
	  }, {
	    key: 'getJson',
	    value: function getJson(url) {
	      return this.getjson(url);
	    }
	  }, {
	    key: 'getjson',
	    value: function getjson(url) {
	      return new _promise2.default(function (resolve, reject) {
	        $.getJSON(url, function (response) {}).done(function (response) {
	          resolve(response);
	        }).fail(function (error) {
	          reject(error);
	        });
	      });
	    }
	  }, {
	    key: 'onSuccess',
	    value: function onSuccess(data) {
	      console.log('uspeh');
	    }
	  }, {
	    key: 'onFail',
	    value: function onFail(errors) {
	      alert(errors);
	      this.errors.record(errors);
	    }
	  }, {
	    key: 'checkIfEmpty',
	    value: function checkIfEmpty(obj) {
	      var err = {};
	      for (var key in obj) {
	        if (obj[key] === '') {
	          err[key] = 'required';
	          this.errors.record(err);
	        }
	      }
	    }
	  }, {
	    key: 'validateEmail',
	    value: function validateEmail(obj) {}
	  }, {
	    key: 'minPasswordLength',
	    value: function minPasswordLength(obj) {
	      var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 8;
	      var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 16;
	
	      var err = {};
	      for (var key in obj) {
	        if (obj[key].length < 8 || obj[key].length > 16) {
	          err[key] = 'pass length';
	        }
	      }
	    }
	  }, {
	    key: 'checkPasswordMatch',
	    value: function checkPasswordMatch(password, confirmPassword) {
	      var err = {};
	      if (confirmPassword !== '' && password !== '' && confirmPassword !== password) {
	        err['confirm_password'] = 'not match';
	        this.errors.record(err);
	      }
	    }
	  }]);
	  return Form;
	}();
	
	exports.default = Form;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 167 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'App',
	  data: function data() {
	    return {
	      form: new Form({})
	    };
	  },
	  sockets: {
	    readMsg: function readMsg(message) {
	      this.$store.commit('GET_MESSAGE', { text: message.text, user: message.user, date: message.date });
	    },
	    initChat: function initChat(messages) {
	      this.$store.commit('INIT_MESSAGES', messages);
	    },
	    updateUsers: function updateUsers(users) {
	      this.$store.commit('INIT_USERS', users);
	    }
	  },
	  created: function created() {
	    if (localStorage.nickname) {
	      this.$store.commit('SET_NAME', localStorage.nickname);
	    }
	    this.checkLogin();
	  },
	  methods: {
	    checkLogin: function checkLogin() {
	      var self = this;
	      if (localStorage.getItem('token_header') && localStorage.getItem('token_log')) {
	        var data = {
	          token_header: localStorage.getItem('token_header'),
	          token_log: localStorage.getItem('token_log'),
	          user_id: localStorage.getItem('user_id')
	        };
	        this.form.post(baseUrl + 'Home/LoginWithToken', data).then(function (result) {
	          if (Number(result.status) === 1) {
	            localStorage.setItem('role', result.role);
	            self.$store.commit('SET_ROLE', Number(result.role));
	            self.$store.commit('SET_NAME', result.nickname);
	            localStorage.setItem('nickname', result.nickname);
	          } else {
	            self.$store.commit('REMOVE_TOKEN');
	            if (window.localStorage) {
	              window.localStorage.removeItem('token_log');
	              window.localStorage.removeItem('token_header');
	              window.localStorage.removeItem('role');
	              window.localStorage.removeItem('user_id');
	              window.localStorage.removeItem('nickname');
	            }
	            self.$router.push('/login');
	          }
	        }, function (reason) {
	          console.log('Rejected', reason);
	        });
	      }
	    }
	  }
	};

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Sidebar = __webpack_require__(300);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _Header = __webpack_require__(299);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(298);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _ControlSidebar = __webpack_require__(297);
	
	var _ControlSidebar2 = _interopRequireDefault(_ControlSidebar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Dashboard',
	  components: {
	    'app-sidebar': _Sidebar2.default,
	    'app-header': _Header2.default,
	    'app-footer': _Footer2.default,
	    'control-sidebar': _ControlSidebar2.default
	  }
	};

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'Login',
	  data: function data() {
	    return {
	      form: new Form({}),
	      credentials: {
	        email: '',
	        password: ''
	      },
	      error: ''
	    };
	  },
	  methods: {
	    Login: function Login() {
	      $('#loading-login').show();
	      var self = this;
	      var data = this.credentials;
	      if (data.email !== '' && data.password !== '') {
	        this.form.post(baseUrl + 'Home/Login', data).then(function (result) {
	          $('#loading-login').hide();
	
	          self.loginProcess(result);
	        }, function (reason) {});
	      } else {
	        this.wrongCredentials = true;
	        $('#loading-login').hide();
	      }
	    },
	    loginProcess: function loginProcess(result) {
	      if (result.status === 1) {
	        if (result.role >= 5) {
	          localStorage.setItem('user_id', result.user_id);
	          localStorage.setItem('role', result.role);
	          localStorage.setItem('token_log', result.token_log);
	          localStorage.setItem('token_header', result.token_header);
	          sessionStorage.removeItem('logout');
	
	          this.$store.commit('SET_TOKEN_LOG', result.token_log);
	          this.$store.commit('SET_TOKEN_HEADER', result.token_header);
	          this.$store.commit('SET_NAME', result.nickname);
	          localStorage.setItem('nickname', result.nickname);
	          this.$store.commit('SET_ROLE', result.role);
	          this.$router.push('/dashboard');
	        } else {
	          this.error = 'You are not an admin';
	        }
	      }
	
	      if (result.status === 0) {
	        this.error = 'Some field is not sent';
	      }
	      if (result.status === 2) {
	        this.error = 'Wrong credentials';
	      }
	    }
	  },
	  mounted: function mounted() {
	    __webpack_require__(272);
	
	    $('input').iCheck({
	      checkboxClass: 'icheckbox_square-blue',
	      radioClass: 'iradio_square-blue',
	      increaseArea: '20%' });
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'NonAnalytic',
	  data: function data() {
	    return {
	      link: '/data/a/a',
	      datetime: '',
	      role: 1,
	      form: new Form({})
	    };
	  },
	  computed: {},
	  methods: {
	    search: function search() {
	      if (this.datetime === '') {
	        this.msg = 'Choose a date';
	        return 0;
	      }
	    },
	    dateToString: function dateToString(date) {
	      var day = date.getDate().toString();
	      day = day.length === 1 ? '0' + day : day;
	      var month = (date.getMonth() + 1).toString();
	      month = month.length === 1 ? '0' + month : month;
	      return month + day;
	    },
	    decoded: function decoded(encoded) {
	      if (encoded === '') {
	        return '';
	      }
	      try {
	        return decodeURI(encoded);
	      } catch (err) {
	        return encoded;
	      }
	    }
	  },
	  mounted: function mounted() {
	    this.role = this.$store.state.role;
	    var self = this;
	    this.datetime = this.dateToString(new Date());
	    document.getElementById('analytics').src = this.link + this.datetime + '.html';
	    if (this.role < 40) {
	      this.$router.push('/dashboard');
	    }
	    window.$ = _jquery2.default;
	    (0, _jquery2.default)(document).ready(function () {
	      (0, _jquery2.default)('#select-server').val((0, _jquery2.default)('#select-server option:first').val());
	      self.server = (0, _jquery2.default)('#select-server option:first').val();
	
	      (0, _jquery2.default)('#datetimepicker1').datetimepicker({
	        locale: 'sr',
	        ignoreReadonly: true,
	        useCurrent: true
	      }).on('dp.show', function () {
	        return (0, _jquery2.default)(this).data('DateTimePicker').defaultDate(new Date());
	      }).on('dp.change', function (e) {
	        self.msg = '';
	        self.datetime = e.date.utc().local().format('MMDD');
	        document.getElementById('analytics').src = self.link + self.datetime + '.html';
	      });
	    });
	  }
	};

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Analytic',
	
	  data: function data() {
	    return {
	      nickname: '',
	      ip: '',
	      server: '',
	      result: [],
	      start: '',
	      end: '',
	      resolution: '',
	      browser: 1,
	      hours: '',
	      minute: '',
	      role: 1
	    };
	  },
	  computed: {},
	  methods: {
	    leadingZero: function leadingZero(num) {
	      var s = num + '';
	      while (s.length < 2) {
	        s = '0' + s;
	      }
	      return s;
	    },
	    browserToggle: function browserToggle() {
	      if (this.browser === 1) {
	        return 'browser';
	      }
	      if (Number(this.browser) === 2) {
	        return 'browserVersion';
	      }
	      if (Number(this.browser) === 3) {
	        return 'browserSize';
	      }
	    },
	    browserToggleClick: function browserToggleClick() {
	      if (this.browser === 1) {
	        this.browser = 2;
	      } else if (this.browser === 2) {
	        this.browser = 3;
	      } else if (this.browser === 3) {
	        this.browser = 1;
	      }
	    },
	    realTime: function realTime() {
	      var today = new Date();
	      var todayString;
	      today.setDate(today.getDate());
	      todayString = today.getFullYear() + '-' + this.leadingZero(today.getMonth() + 1) + '-' + this.leadingZero(today.getDate());
	      this.start = todayString;
	      this.end = todayString;
	      this.hours = this.leadingZero(today.getHours());
	
	      this.queryReports();
	    },
	    queryReports: function queryReports() {
	      var self = this;
	      this.result = [];
	      var endToSend = this.end;
	      var startToSend = this.start;
	      if (startToSend.length !== 10) {
	        startToSend = '30daysAgo';
	      }
	      if (endToSend.length !== 10) {
	        endToSend = 'today';
	      }
	      console.log('Pregraga....\nIP: ' + self.ip + ' | Server: ' + self.server + ' | Interval: ' + this.start + ' - ' + this.end);
	      gapi.client.request({
	        path: '/v4/reports:batchGet',
	        root: 'https://analyticsreporting.googleapis.com/',
	        method: 'POST',
	        body: {
	          reportRequests: [{
	            viewId: '152038660',
	            samplingLevel: 'LARGE',
	            dateRanges: [{
	              startDate: startToSend,
	              endDate: endToSend
	            }],
	            metrics: [{
	              expression: 'ga:uniqueEvents'
	            }, {
	              expression: 'ga:eventValue'
	            }],
	
	            orderBys: [{ fieldName: 'ga:uniqueEvents', sortOrder: 'DESCENDING' }],
	            dimensions: [{
	              name: 'ga:eventLabel'
	            }, {
	              name: 'ga:eventAction'
	            }, {
	              name: 'ga:eventCategory'
	            }, {
	              name: 'ga:city'
	            }, {
	              name: 'ga:country'
	            }, {
	              name: 'ga:operatingSystem'
	            }, {
	              name: 'ga:operatingSystemVersion'
	            }, {
	              name: 'ga:' + self.browserToggle()
	            }, {
	              name: 'ga:screenResolution'
	            }],
	            dimensionFilterClauses: [{
	              filters: [{
	                dimensionName: 'ga:eventCategory',
	                operator: 'PARTIAL',
	                expressions: [self.server]
	              }]
	            }, {
	              filters: [{
	                dimensionName: 'ga:eventAction',
	                operator: 'PARTIAL',
	                expressions: [self.nickname]
	              }]
	            }, {
	              filters: [{
	                dimensionName: 'ga:eventLabel',
	                operator: 'PARTIAL',
	                expressions: [self.ip]
	              }]
	            }, {
	              filters: [{
	                dimensionName: 'ga:screenResolution',
	                operator: 'PARTIAL',
	                expressions: [self.resolution]
	              }]
	            }, {
	              filters: [{
	                dimensionName: 'ga:hour',
	                operator: 'PARTIAL',
	                expressions: [self.hours]
	              }]
	            }, {
	              filters: [{
	                dimensionName: 'ga:minute',
	                operator: 'PARTIAL',
	                expressions: [self.minute]
	              }]
	            }]
	          }]
	        }
	      }).then(self.displayResults, console.error.bind(console));
	    },
	    displayResults: function displayResults(response) {
	      this.result = response.result.reports[0].data.rows;
	      if (!response.result.reports[0].data.rowCount) {
	        alert('Nema rezultata');
	      }
	    }
	  },
	  mounted: function mounted() {
	    this.role = this.$store.state.role;
	    if (this.role < 33) {
	      this.$router.push('/dashboard');
	    }
	
	    var self = this;
	    window.$ = _jquery2.default;
	    (0, _jquery2.default)(document).ready(function () {
	      var priorDate = new Date();
	      var startDateString;
	
	      priorDate.setDate(priorDate.getDate() - 30);
	      startDateString = priorDate.getFullYear() + '-' + self.leadingZero(priorDate.getMonth() + 1) + '-' + self.leadingZero(priorDate.getDate());
	
	      var endDate = new Date();
	      var endDateString;
	      endDate.setDate(endDate.getDate());
	      endDateString = endDate.getFullYear() + '-' + self.leadingZero(endDate.getMonth() + 1) + '-' + self.leadingZero(endDate.getDate());
	      self.start = startDateString;
	      self.end = endDateString;
	      if (self.role >= 33) {
	        setTimeout(function () {
	          self.queryReports();
	        }, 2000);
	      } else {
	        setTimeout(function () {
	          (0, _jquery2.default)('#select-server').val((0, _jquery2.default)('#select-server option:first').val());
	          self.server = (0, _jquery2.default)('#select-server option:first').val();
	        }, 1000);
	      }
	    });
	  }
	};

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'Ban',
	  data: function data() {
	    return {
	      bannedList: [],
	      form: new Form({}),
	      current_date: new Date().toISOString().slice(0, 19).replace('T', ' '),
	      nickname: '',
	      ip: '',
	      date_to: '',
	      reason: '',
	      type: 0,
	      msg: ''
	    };
	  },
	  mounted: function mounted() {
	    if (Number(this.$store.state.role) < 33) {
	      this.$router.push('/dashboard');
	    }
	    var self = this;
	    $(function () {
	      $('#datetimepicker').datetimepicker({
	        locale: 'sr'
	      });
	      $(document).on('dp.change', '#datetimepicker', function (e) {
	        self.date_to = e.date.utc().format();
	      });
	    });
	    this.getBannedList();
	  },
	  methods: {
	    getBannedList: function getBannedList() {
	      var self = this;
	
	
	      this.form.post(baseUrl + 'Agar/getBannedList', {}).then(function (result) {
	        if (result.status === 1) {
	          self.bannedList = result.banned;
	        }
	      }, function (reason) {});
	    },
	
	    unban: function unban(id) {
	      var self = this;
	      var data = {
	        id: id,
	        token_header: localStorage.getItem('token_header'),
	        token_log: localStorage.getItem('token_log')
	      };
	      this.form.post(baseUrl + 'Admin/unbanUser', data).then(function (result) {
	        if (Number(result.status) === 1) {
	          self.bannedList = [];
	          self.getBannedList();
	        }
	      }, function (reason) {});
	    },
	    ban: function ban() {
	      if (this.date_to === '') {
	        this.msg = 'Choose date';
	        return 0;
	      }
	      if (this.ip === '') {
	        this.msg = 'Must enter IP address';
	        return 0;
	      }
	      if (this.type < 1 || this.type > 6) {
	        this.msg = 'Choose type';
	        return 0;
	      }
	      var self = this;
	      var data = {
	        nickname: encodeURI(this.nickname),
	        ip: this.ip,
	        reason: this.reason,
	        date_to: this.date_to,
	        type: this.type,
	        token_header: localStorage.getItem('token_header'),
	        token_log: localStorage.getItem('token_log'),
	        by: this.$store.state.nickname
	      };
	      this.msg = '';
	      this.form.post(baseUrl + 'Admin/banUser', data).then(function (result) {
	        if (Number(result.status) === 1) {
	          self.nickname = '';
	          self.reason = '';
	          self.date_to = '';
	          self.type = 0;
	          self.ip = '';
	
	          self.bannedList = [];
	          self.getBannedList();
	        } else {
	          self.msg = result.msg;
	        }
	      }, function (reason) {});
	    },
	
	    calcType: function calcType(type) {
	      if (Number(type) === 1) return 'Igra';
	      if (Number(type) === 2) return 'Chat';
	      if (Number(type) === 3) return 'Skinovi';
	      if (Number(type) === 4) return 'Kill';
	      if (Number(type) === 5) return 'Poruka';
	      if (Number(type) === 6) return 'Potres';
	    },
	    calcServers: function calcServers(servers) {
	      if (servers === '') return 'Svi';
	      return servers;
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(199);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(160);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Admin',
	  data: function data() {
	    return {
	      role: 1,
	      userName: '',
	      message: ''
	    };
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    messages: function messages(state) {
	      return state.chat.messages;
	    },
	    users: function users(state) {
	      return state.chat.users;
	    }
	  })),
	  methods: {
	    decoded: function decoded(encoded) {
	      if (encoded === '') {
	        return '';
	      }
	      try {
	        return decodeURI(encoded);
	      } catch (err) {
	        return encoded;
	      }
	    },
	    sendMessage: function sendMessage() {
	      if (this.message.length > 0) {
	        this.$socket.emit('send-msg', { message: this.message, user: this.userName });
	        this.message = '';
	      }
	    },
	    scrollToEnd: function scrollToEnd() {
	      var container = this.$el.querySelector('.messages');
	      container.scrollTop = container.scrollHeight;
	    }
	  },
	  mounted: function mounted() {
	    if (this.$store.state.nickname != null) {
	      this.userName = this.$store.state.nickname;
	    } else {
	      this.userName = 'Admin 03';
	    }
	    this.$socket.emit('add-user', this.userName);
	  },
	  updated: function updated() {
	    this.scrollToEnd();
	  }
	};

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'History',
	  data: function data() {
	    return {
	      nickname: '',
	      ip: '',
	      client: '',
	      server: '',
	      message: '',
	      datetime: '',
	      role: 1,
	      result: [],
	      resultLength: 0,
	      searching: 0,
	      form: new Form({}),
	      msg: '',
	      selectedMessage: {},
	      returnedDateTime: '',
	      localStorageNicknames: '',
	      ipinfo: {
	        'city': '',
	        'country': '',
	        'region': '',
	        'isp': '',
	        'status': ''
	      },
	      ban: {
	        nickname: '',
	        ip: '',
	        date_to: '',
	        reason: '',
	        type: 0,
	        msg: ''
	      }
	    };
	  },
	  computed: {},
	  methods: {
	    search: function search() {
	      if (this.datetime === '') {
	        this.msg = 'Choose a date';
	        return 0;
	      }
	      if (this.ip !== '') {
	        this.ip = this.ip.trim();
	      }
	      var self = this;
	      this.searching = 1;
	      var data = {
	        nickname: encodeURI(this.nickname),
	        ip: this.ip,
	        datetime: this.datetime,
	        server: this.server,
	        message: encodeURI(this.message),
	        client: this.client,
	        token_header: localStorage.getItem('token_header'),
	        token_log: localStorage.getItem('token_log')
	      };
	      self.result = [];
	      self.resultLength = 0;
	      (0, _jquery2.default)('[data-toggle="tooltip"]').tooltip();
	      this.msg = '';
	      this.form.post(baseUrl + 'Admin/readMessage', data).then(function (result) {
	        if (Number(result.status) === 1) {
	          self.result = result.messages.slice();
	          self.resultLength = self.result.length;
	          self.returnedDateTime = result.datetime;
	          setTimeout(function () {
	            (0, _jquery2.default)('[data-toggle="tooltip"]').tooltip();
	          }, 500);
	        } else {
	          (0, _jquery2.default)('.chat-box').html('Došlo je do greške: ', result.msg);
	          self.msg = result.msg;
	        }
	        self.searching = 0;
	      }, function (reason) {
	        alert(reason);
	      });
	    },
	    decoded: function decoded(encoded) {
	      if (encoded === '') {
	        return '';
	      }
	      try {
	        return decodeURI(encoded);
	      } catch (err) {
	        return encoded;
	      }
	    },
	    saveLocalNicknames: function saveLocalNicknames() {
	      localStorage.setItem('savedNicknames', this.localStorageNicknames);
	      (0, _jquery2.default)('#myModal').modal('close');
	    },
	    loadMore: function loadMore() {
	      if (this.result.length === 0) {
	        return 0;
	      }
	      var LastId = this.result[this.result.length - 1];
	      this.searching = 1;
	      var data = {
	        nickname: encodeURI(this.nickname),
	        ip: this.ip,
	        datetime: this.datetime,
	        server: this.server,
	        message: encodeURI(this.message),
	        last_id: LastId['id'],
	        client: this.client,
	        token_header: localStorage.getItem('token_header'),
	        token_log: localStorage.getItem('token_log')
	      };
	      var self = this;
	      self.resultLength = 0;
	      (0, _jquery2.default)('[data-toggle="tooltip"]').tooltip();
	      this.msg = '';
	      this.form.post(baseUrl + 'Admin/readMessageNext', data).then(function (result) {
	        if (Number(result.status) === 1) {
	          self.result = self.result.concat(result.messages.slice());
	          self.resultLength = result.messages.slice().length;
	          self.returnedDateTime = result.datetime;
	          setTimeout(function () {
	            (0, _jquery2.default)('[data-toggle="tooltip"]').tooltip();
	          }, 500);
	        } else {
	          (0, _jquery2.default)('.chat-box').html('Došlo je do greške: ', result.msg);
	          self.msg = result.msg;
	        }
	        self.searching = 0;
	      }, function (reason) {
	        alert(reason);
	      });
	    },
	    takeAction: function takeAction(item) {
	      this.selectedMessage = item;
	      this.ban.nickname = this.decoded(item.nickname);
	      this.ban.ip = item.ip;
	      if (this.role >= 40) {
	        this.getIpInfo(item.ip);
	      }
	    },
	    getIpInfo: function getIpInfo(ip) {
	      var self = this;
	
	      this.form.post('https://ipapi.co/' + ip + '/json/', {}).then(function (result) {
	        self.ipinfo['city'] = result['city'] + ' / ' + result['region'] + ' / ' + result['postal'];
	        self.ipinfo['country'] = result['country_name'];
	        self.ipinfo['region'] = result['region'];
	        self.ipinfo['isp'] = result['org'];
	        self.ipinfo['status'] = true;
	      }, function (reason) {});
	    },
	    banPlayer: function banPlayer() {
	      if (this.ban.date_to === '') {
	        this.ban.msg = 'Choose date';
	        return 0;
	      }
	      if (this.ban.ip === '') {
	        this.ban.msg = 'Must enter IP address';
	        return 0;
	      }
	      if (this.ban.type < 1 || this.ban.type > 6) {
	        this.ban.msg = 'Choose type';
	        return 0;
	      }
	      var self = this;
	      var data = {
	        nickname: encodeURI(this.ban.nickname),
	        ip: this.ban.ip,
	        reason: this.ban.reason,
	        date_to: this.ban.date_to,
	        type: this.ban.type,
	        token_header: localStorage.getItem('token_header'),
	        token_log: localStorage.getItem('token_log'),
	        by: this.$store.state.nickname
	      };
	      this.ban.msg = '';
	      this.form.post(baseUrl + 'Admin/banUser', data).then(function (result) {
	        if (Number(result.status) === 1) {
	          self.ban.nickname = '';
	          self.ban.reason = '';
	          self.ban.date_to = '';
	          self.ban.type = 0;
	          self.ban.ip = '';
	        } else {
	          self.ban.msg = result.msg;
	        }
	      }, function (reason) {});
	    }
	  },
	  mounted: function mounted() {
	    this.role = this.$store.state.role;
	    var self = this;
	
	    if (this.role >= 33) {
	      (0, _jquery2.default)('#select-server').addClass('half-select');
	    }
	    window.$ = _jquery2.default;
	    (0, _jquery2.default)(document).ready(function () {
	      (0, _jquery2.default)('#select-server').val((0, _jquery2.default)('#select-server option:first').val());
	      self.server = (0, _jquery2.default)('#select-server option:first').val();
	
	      (0, _jquery2.default)('#datetimepicker12').datetimepicker({
	        inline: true,
	        sideBySide: true,
	
	        locale: 'sr',
	        ignoreReadonly: true,
	        useCurrent: true
	      }).on('dp.show', function () {
	        return (0, _jquery2.default)(this).data('DateTimePicker').defaultDate(new Date());
	      }).on('dp.change', function (e) {
	        self.msg = '';
	        self.datetime = e.date.utc().local().format('YYYY-MM-DD HH:mm:ss');
	      });
	
	      (0, _jquery2.default)('#datetimepicker').datetimepicker({
	        locale: 'sr'
	      });
	      (0, _jquery2.default)(document).on('dp.change', '#datetimepicker', function (e) {
	        self.ban.date_to = e.date.utc().local().format();
	      });
	
	      if (localStorage.savedNicknames) {
	        self.localStorageNicknames = localStorage.savedNicknames;
	      }
	    });
	  }
	};

/***/ }),
/* 175 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'ChatsIndex',
	  data: function data() {
	    return {
	      servers: [],
	      form: new Form({}),
	      nickname: 'SERVER'
	    };
	  },
	  computed: {
	    safeName: function safeName() {
	      return encodeURIComponent(this.nickname);
	    }
	  },
	  mounted: function mounted() {
	    var self = this;
	
	    this.nickname = this.$store.state.nickname;
	    setTimeout(function () {
	      self.nickname = self.$store.state.nickname;
	      self.form.post(baseUrl2 + '/data/servers.php', {}).then(function (result) {
	        self.servers = result.servers;
	      }, function (reason) {
	        console.log('Rejected', reason);
	      });
	    }, 500);
	  }
	};

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'Coins',
	  data: function data() {
	    return {
	      transactions: [],
	      userList: [],
	      userInfo: {},
	      form: new Form({}),
	      term: '',
	      type: 'nickname',
	      selected_user: 0,
	      coins_number: 0,
	      reason: '',
	      msg: ''
	    };
	  },
	  created: function created() {
	    if (Number(this.$store.state.role) < 30) {
	      this.$router.push('/dashboard');
	    }
	  },
	  mounted: function mounted() {
	    var self = this;
	    $(function () {
	      $('#datetimepicker').datetimepicker({
	        locale: 'sr'
	      });
	      $(document).on('dp.change', '#datetimepicker', function (e) {
	        self.date_to = e.date.utc().format();
	      });
	    });
	    this.getTransactions();
	  },
	  methods: {
	    getTransactions: function getTransactions() {
	      var self = this;
	      var data = {
	        token_header: localStorage.getItem('token_header'),
	        token_log: localStorage.getItem('token_log')
	      };
	      this.form.post(baseUrl + 'Admin/getLatestTransactions', data).then(function (result) {
	        if (result.status === 1) {
	          self.transactions = result.transactions;
	        }
	      }, function (reason) {});
	    },
	    searchUser: function searchUser() {
	      var self = this;
	      this.userList = [];
	      var searchTerm = this.term;
	      if (this.type === 'nickname') {
	        searchTerm = encodeURI(this.term);
	      }
	      var data = {
	        term: searchTerm,
	        by: this.type,
	        token_header: localStorage.getItem('token_header'),
	        token_log: localStorage.getItem('token_log')
	      };
	      if (this.term.length > 2 || this.type === 'id') {
	        this.form.post(baseUrl + 'Admin/searchUser', data).then(function (result) {
	          if (result.status === 1) {
	            self.userList = result.list;
	          }
	        }, function (reason) {});
	      }
	    },
	
	    pickUser: function pickUser(user) {
	      this.userInfo = user;
	      this.selected_user = Number(user.id);
	      this.userList = [];
	      this.term = '';
	    },
	    addCoins: function addCoins() {
	      var self = this;
	      var data = {
	        token_header: localStorage.getItem('token_header'),
	        token_log: localStorage.getItem('token_log'),
	        user_id: this.selected_user,
	        from_admin: localStorage.getItem('user_id'),
	        reason: this.reason,
	        coins_number: this.coins_number
	      };
	      this.form.post(baseUrl + 'Admin/addCoins', data).then(function (result) {
	        self.msg = result.msg;
	        if (Number(result.status) === 1) {
	          window.location.reload();
	        }
	      }, function (reason) {
	        console.log('Rejected', reason);
	      });
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Highscores',
	  data: function data() {
	    return {
	      private: [],
	      public: [],
	      form: new Form({}),
	      reason: '',
	      msg: ''
	    };
	  },
	  created: function created() {
	    if (Number(this.$store.state.role) < 33) {
	      this.$router.push('/dashboard');
	    }
	  },
	  mounted: function mounted() {
	    var self = this;
	    (0, _jquery2.default)(function () {
	      (0, _jquery2.default)('#datetimepicker').datetimepicker({
	        locale: 'sr'
	      });
	      (0, _jquery2.default)(document).on('dp.change', '#datetimepicker', function (e) {
	        self.date_to = e.date.utc().format();
	      });
	    });
	    this.getTransactions();
	  },
	  methods: {
	    getTransactions: function getTransactions() {
	      var self = this;
	      this.form.post(baseUrl + 'Admin/getLatestTransactions', {}).then(function (result) {
	        if (result.status === 1) {
	          self.transactions = result.transactions;
	        }
	      }, function (reason) {});
	    },
	    searchUser: function searchUser() {
	      var self = this;
	      this.userList = [];
	      var searchTerm = this.term;
	      if (this.type === 'nickname') {
	        searchTerm = encodeURI(this.term);
	      }
	      var data = {
	        term: searchTerm,
	        by: this.type
	      };
	      if (this.term.length > 2 || this.type === 'id') {
	        this.form.post(baseUrl + 'Admin/searchUser', data).then(function (result) {
	          if (result.status === 1) {
	            self.userList = result.list;
	          }
	        }, function (reason) {});
	      }
	    },
	
	    pickUser: function pickUser(user) {
	      this.userInfo = user;
	      this.selected_user = Number(user.id);
	      this.userList = [];
	      this.term = '';
	    },
	    addCoins: function addCoins() {
	      var self = this;
	      var data = {
	        token_header: localStorage.getItem('token_header'),
	        token_log: localStorage.getItem('token_log'),
	        user_id: this.selected_user,
	        from_admin: localStorage.getItem('user_id'),
	        reason: this.reason,
	        coins_number: this.coins_number
	      };
	      this.form.post(baseUrl + 'Admin/addCoins', data).then(function (result) {
	        self.msg = result.msg;
	        if (Number(result.status) === 1) {
	          window.location.reload();
	        }
	      }, function (reason) {
	        console.log('Rejected', reason);
	      });
	    }
	  }
	};

/***/ }),
/* 178 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'NotFound'
	};

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'SQL',
	  data: function data() {
	    return {
	      state: '',
	      role: 1,
	      result: [],
	      resultLength: 0,
	      searching: 0,
	      form: new Form({}),
	      msg: '',
	      status: 0,
	      localStorageQueries: '',
	      ipinfo: {
	        'city': '',
	        'country': '',
	        'region': '',
	        'isp': '',
	        'status': ''
	      }
	    };
	  },
	  computed: {},
	  methods: {
	    executeSQL: function executeSQL() {
	      console.log('executing: ' + this.state);
	      if (this.state === '') {
	        this.msg = 'Enter SQL state';
	        this.status = -1;
	        return 0;
	      }
	      var self = this;
	      this.searching = 1;
	      this.status = 0;
	      var data = {
	        state: this.state,
	        token_header: localStorage.getItem('token_header'),
	        token_log: localStorage.getItem('token_log')
	      };
	      self.result = [];
	      self.resultLength = 0;
	      this.msg = '';
	      this.form.post(baseUrl + 'Admin/executeSQL', data).then(function (result) {
	        if (Number(result.status) === 1) {
	          self.result = result.data.slice();
	          self.resultLength = self.result.length;
	          self.msg = result.query;
	          self.status = 1;
	        } else {
	          self.msg = result.msg;
	          self.status = -1;
	        }
	        self.searching = 0;
	      }, function (reason) {
	        self.msg = reason;
	        self.status = -1;
	      });
	    },
	    decoded: function decoded(encoded) {
	      if (encoded === '') {
	        return '';
	      }
	      try {
	        return decodeURI(encoded);
	      } catch (err) {
	        return encoded;
	      }
	    },
	    saveLocalQueries: function saveLocalQueries() {
	      localStorage.setItem('savedQueries', this.localStorageQueries);
	      (0, _jquery2.default)('#myModal').modal('close');
	    },
	    getIpInfo: function getIpInfo(ip) {
	      var self = this;
	      self.ipinfo = {};
	      this.form.post('https://ipapi.co/' + ip + '/json/', {}).then(function (result) {
	        self.ipinfo['city'] = result['city'] + ' / ' + result['region'] + ' / ' + result['postal'];
	        self.ipinfo['country'] = result['country_name'];
	        self.ipinfo['region'] = result['region'];
	        self.ipinfo['isp'] = result['org'];
	        self.ipinfo['status'] = true;
	      }, function (reason) {});
	    }
	  },
	  mounted: function mounted() {
	    this.role = this.$store.state.role;
	    var self = this;
	
	    if (Number(this.$store.state.role) < 40) {
	      this.$router.push('/dashboard');
	    }
	    window.$ = _jquery2.default;
	    if (localStorage.savedQueries) {
	      self.localStorageQueries = localStorage.savedQueries;
	    }
	  }
	};

/***/ }),
/* 180 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'dashboardHome',
	  data: function data() {
	    return {
	
	      number_of_users: 0,
	      number_of_private_skins: 0,
	      number_of_skins: 0,
	      form: new Form({}),
	      fullAdmin: 0
	    };
	  },
	  mounted: function mounted() {
	    var self = this;
	    this.fullAdmin = this.$store.state.role;
	    this.form.post(baseUrl + 'Admin/agarStructure').then(function (result) {
	      self.number_of_skins = result.info.number_of_skins;
	      self.number_of_private_skins = result.info.number_of_private_skins;
	      self.number_of_users = result.info.number_of_users;
	    }, function (reason) {});
	  }
	};

/***/ }),
/* 181 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'ServersData',
	  data: function data() {
	    return {
	      servers: [],
	      role: 1,
	      form: new Form({})
	    };
	  },
	  mounted: function mounted() {
	    this.role = this.$store.state.role;
	    var self = this;
	    this.form.post(baseUrl2 + '/data/servers.php', {}).then(function (result) {
	      self.servers = result.servers;
	    }, function (reason) {
	      console.log('Rejected', reason);
	    });
	  }
	};

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'Skins',
	
	  data: function data() {
	    return {
	      baseUrl2: 'https://agar.rs',
	      loading: true,
	      rename: false,
	      skins: new Form({
	        images: [],
	        visible_images: [],
	        skin_name: ''
	      }),
	      skinSearch: '',
	      isActiveSearch: false,
	      scrollCalled: 0,
	      isLoadingNew: false,
	      role: 1,
	      bigScreenSkins: 3
	
	    };
	  },
	  methods: {
	    getSkinsDB: function getSkinsDB() {
	      var self = this;
	      this.skins.post(baseUrl + 'Skins/getSkinList/1').then(function (result) {
	        self.skins.images = result.list;
	        self.skins.visible_images = result.list;
	        self.loading = false;
	      }, function (reason) {});
	    },
	    getSkinsDBNext: function getSkinsDBNext() {
	      var self = this;
	
	      this.isLoadingNew = true;
	      var data = {};
	      data['position'] = $('.card').last().attr('data-skin-id');
	
	      this.skins.post(baseUrl + 'Skins/getSkinListNext/1', data).then(function (result) {
	        self.skins.visible_images = self.skins.visible_images.concat(result.list);
	        self.scrollCalled = 0;
	        self.isLoadingNew = false;
	      }, function (reason) {});
	    },
	    skinSearchDB: function skinSearchDB() {
	      var self = this;
	      if (this.skinSearch.length === 0) {
	        this.skins.visible_images = this.skins.images.slice();
	      }
	      if (this.skinSearch.length > 2) {
	        this.isActiveSearch = true;
	        var data = {};
	        data['term'] = this.skinSearch;
	        this.skins.visible_images = [];
	        this.skins.post(baseUrl + 'Skins/searchSkin/1', data).then(function (result) {
	          if (result.status === 1) {
	            self.skins.visible_images = result.list.slice();
	            self.isActiveSearch = false;
	          }
	        }, function (reason) {});
	      }
	    },
	
	    renameSkinDB: function renameSkinDB(oldname, meta) {
	      var name = $(meta).prev('input').val();
	      var data = {
	        'user_id': localStorage.user_id,
	        'token_header': localStorage.token_header,
	        'token_log': localStorage.token_log,
	        'name': name,
	        'oldname': oldname
	      };
	
	      this.skins.post(baseUrl + 'Skins/renameSkin', data).then(function (result) {
	        if (result.status === 1) {}
	
	        if (result.status !== 1) {
	          alert('Greska. Ime verovatno postoji. Probaj drugo ime');
	        }
	      }, function (reason) {});
	    },
	    safeSkin: function safeSkin(id, name, safe) {
	      var self = this;
	      var data = {
	        'user_id': localStorage.user_id,
	        'token_header': localStorage.token_header,
	        'token_log': localStorage.token_log,
	        'name': name,
	        'id': id,
	        'safe': safe
	      };
	      this.skins.post(baseUrl + 'Skins/toSafeSkins', data).then(function (result) {
	        if (result.status === 1) {
	          self.skins.visible_images.find(function (o, i) {
	            if (o.skin_name === data.name) {
	              if (i >= 0) {
	                o.safe = data.safe;
	                return 0;
	              }
	            }
	          });
	        }
	      }, function (reason) {});
	    },
	    removeSkinDB: function removeSkinDB(id, name) {
	      var self = this;
	      var data = {
	        'user_id': localStorage.user_id,
	        'token_header': localStorage.token_header,
	        'token_log': localStorage.token_log,
	        'name': name,
	        'id': id
	      };
	      this.skins.post(baseUrl + 'Skins/removeSkin', data).then(function (result) {
	        if (result.status === 1) {
	          self.skins.visible_images.find(function (o, i) {
	            if (o.skin_name === name) {
	              if (i >= 0) {
	                self.skins.visible_images.splice(i, 1);
	                return 0;
	              }
	            }
	          });
	        }
	        if (result.status === 2) {
	          localStorage.setItem('role', result.role);
	        }
	
	        if (result.status !== 1) {
	          alert('Greska. Skin je vec obrisan');
	        }
	      }, function (reason) {});
	    }
	  },
	  updated: function updated() {
	    var self = this;
	
	    $(window).scroll(function (event) {
	      if (self.scrollCalled === 0) {
	        if ($(this).scrollTop() + $(this).innerHeight() >= $('body')[0].scrollHeight) {
	          if (self.skinSearch.length < 3) {
	            self.scrollCalled = 1;
	            self.getSkinsDBNext();
	          }
	        }
	      }
	    });
	  },
	
	  created: function created() {
	    if (screen.width > 1500) {
	      this.bigScreenSkins = 2;
	    }
	    this.getSkinsDB();
	    this.role = this.$store.state.role;
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'Pending',
	
	  data: function data() {
	    return {
	      baseUrl2: 'https://agar.rs',
	      loading: true,
	      rename: false,
	      skins: new Form({
	        images: [],
	        visible_images: [],
	        skin_name: ''
	      }),
	      skinSearch: '',
	      isActiveSearch: false,
	      scrollCalled: 0,
	      isLoadingNew: false,
	      role: 1,
	      bigScreenSkins: 3
	
	    };
	  },
	  methods: {
	    getSkinsDB: function getSkinsDB() {
	      var self = this;
	      this.skins.post(baseUrl + 'Skins_v2/get_pending_skins').then(function (result) {
	        self.skins.images = result.list;
	        self.skins.visible_images = result.list;
	        self.$store.commit('SET_SKINS', Number(result.list.length));
	        self.loading = false;
	      }, function (reason) {});
	    },
	    skinSearchDB: function skinSearchDB() {
	      var self = this;
	      if (this.skinSearch.length === 0) {
	        this.skins.visible_images = this.skins.images.slice();
	      }
	      if (this.skinSearch.length > 2) {
	        this.isActiveSearch = true;
	        var data = {};
	        data['term'] = this.skinSearch;
	        this.skins.visible_images = [];
	        this.skins.post(baseUrl + 'Skins_v2/search_skin', data).then(function (result) {
	          if (result.status === 1) {
	            self.skins.visible_images = result.list.slice();
	            self.isActiveSearch = false;
	          }
	        }, function (reason) {});
	      }
	    },
	
	    renameSkinDB: function renameSkinDB(oldname, meta) {
	      var name = $(meta).prev('input').val();
	      var data = {
	        'user_id': localStorage.user_id,
	        'token_header': localStorage.token_header,
	        'token_log': localStorage.token_log,
	        'name': name,
	        'oldname': oldname
	      };
	
	      this.skins.post(baseUrl + 'Skins/renameSkin', data).then(function (result) {
	        if (result.status === 1) {}
	
	        if (result.status !== 1) {
	          alert('Greska. Ime verovatno postoji. Probaj drugo ime');
	        }
	      }, function (reason) {});
	    },
	
	    removeSkinDB: function removeSkinDB(item, name) {
	      var self = this;
	      var data = {
	        'id': item,
	        'name': name
	      };
	      console.log(data);
	      this.skins.post(baseUrl + 'Skins/declineSkin', data).then(function (result) {
	        if (result.status === 1) {
	          self.skins.visible_images.find(function (o, i) {
	            if (o.skin_name === name) {
	              if (i >= 0) {
	                self.skins.visible_images.splice(i, 1);
	                self.$store.commit('SET_SKINS', self.$store.state.waitSkins - 1);
	                return 0;
	              }
	            }
	          });
	        } else {
	          alert('Skin je vec obrisan');
	        }
	      }, function (reason) {});
	    },
	    approveSkin: function approveSkin(item) {
	      var self = this;
	      var data = {
	        'by': localStorage.user_id,
	
	        'name': item
	      };
	      this.skins.post(baseUrl + 'Skins_v2/accept_skin', data).then(function (result) {
	        if (result.status === 1) {
	          self.skins.visible_images.find(function (o, i) {
	            if (o.skin_name === item) {
	              if (i >= 0) {
	                self.skins.visible_images.splice(i, 1);
	                self.$store.commit('SET_SKINS', self.$store.state.waitSkins - 1);
	                return 0;
	              }
	            }
	          });
	        } else {
	          alert('Skin sa tim imenom vec postoji. Promeni ime skina');
	        }
	      }, function (reason) {});
	    }
	  },
	  updated: function updated() {},
	
	  created: function created() {
	    if (screen.width > 1500) {
	      this.bigScreenSkins = 2;
	    }
	    this.getSkinsDB();
	    this.role = this.$store.state.role;
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 184 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'privateWaiting',
	
	  data: function data() {
	    return {
	      baseUrl2: 'https://agar.rs',
	      loading: true,
	      rename: false,
	      skins: new Form({
	        images: [],
	        visible_images: [],
	        skin_name: ''
	      }),
	      skinSearch: '',
	      isActiveSearch: false,
	      scrollCalled: 0,
	      isLoadingNew: false,
	      role: 1,
	      bigScreenSkins: 3
	
	    };
	  },
	  methods: {
	    getSkinsDB: function getSkinsDB() {
	      var self = this;
	      this.skins.post(baseUrl + 'Skins/getWaitingPrivateSkinList').then(function (result) {
	        self.skins.images = result.list;
	        self.skins.visible_images = result.list;
	        self.$store.commit('SET_PRIVATE_SKINS', Number(result.list.length));
	        self.loading = false;
	      }, function (reason) {});
	    },
	
	    removeSkinDB: function removeSkinDB(item, id) {
	      var self = this;
	      var data = {
	        'token_header': localStorage.token_header,
	        'token_log': localStorage.token_log,
	        'name': item,
	        'id': id
	      };
	      this.skins.post(baseUrl + 'Skins/declinePrivateSkin', data).then(function (result) {
	        if (result.status === 1) {
	          self.skins.visible_images.find(function (o, i) {
	            if (o.skin_name === item) {
	              if (i >= 0) {
	                self.skins.visible_images.splice(i, 1);
	                self.$store.commit('SET_PRIVATE_SKINS', self.$store.state.waitPrivateSkins - 1);
	                return 0;
	              }
	            }
	          });
	        } else {
	          alert('Greska. Skin je vec obrisan');
	        }
	      }, function (reason) {});
	    },
	    approveSkin: function approveSkin(item, id) {
	      var self = this;
	      var data = {
	        'token_header': localStorage.token_header,
	        'token_log': localStorage.token_log,
	        'name': item,
	        'id': id,
	        'by': localStorage.user_id
	      };
	      this.skins.post(baseUrl + 'Skins/acceptPrivateSkin', data).then(function (result) {
	        if (result.status === 1) {
	          self.skins.visible_images.find(function (o, i) {
	            if (o.skin_name === item) {
	              if (i >= 0) {
	                self.skins.visible_images.splice(i, 1);
	                self.$store.commit('SET_PRIVATE_SKINS', self.$store.state.waitPrivateSkins - 1);
	                return 0;
	              }
	            }
	          });
	        } else {
	          alert('Skin sa tim imenom vec postoji. Promeni ime skina');
	        }
	      }, function (reason) {});
	    }
	  },
	  updated: function updated() {},
	
	  created: function created() {
	    if (screen.width > 1500) {
	      this.bigScreenSkins = 2;
	    }
	    this.getSkinsDB();
	    this.role = this.$store.state.role;
	  }
	};

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'Private',
	
	  data: function data() {
	    return {
	      baseUrl2: 'https://agar.rs',
	      loading: true,
	      skins: new Form({
	        images: [],
	        visible_images: [],
	        skin_name: ''
	      }),
	      skinSearch: '',
	      isActiveSearch: false,
	      scrollCalled: 0,
	      isLoadingNew: false,
	      role: 1,
	      bigScreenSkins: 3
	
	    };
	  },
	  methods: {
	    getSkinsDB: function getSkinsDB() {
	      var self = this;
	      this.skins.post(baseUrl + 'Skins/getPrivateSkinList').then(function (result) {
	        self.skins.images = result.list;
	        self.skins.visible_images = result.list;
	        self.loading = false;
	      }, function (reason) {});
	    },
	    getSkinsDBNext: function getSkinsDBNext() {
	      var self = this;
	
	      this.isLoadingNew = true;
	      var data = {};
	      data['position'] = $('.card').last().attr('data-skin-id');
	
	      this.skins.post(baseUrl + 'Skins/getPrivateSkinListNext', data).then(function (result) {
	        self.skins.visible_images = self.skins.visible_images.concat(result.list);
	        self.scrollCalled = 0;
	        self.isLoadingNew = false;
	      }, function (reason) {});
	    },
	
	    removePrivateSkinDB: function removePrivateSkinDB(id, name) {
	      var self = this;
	      var data = {
	        'user_id': localStorage.user_id,
	        'token_header': localStorage.token_header,
	        'token_log': localStorage.token_log,
	        'name': name,
	        'id': id
	      };
	      this.skins.post(baseUrl + 'Skins/removePrivateSkin', data).then(function (result) {
	        if (result.status === 1) {
	          self.skins.visible_images.find(function (o, i) {
	            if (o.skin_name === data.name) {
	              if (i >= 0) {
	                self.skins.visible_images.splice(i, 1);
	                return 0;
	              }
	            }
	          });
	        }
	        if (result.status === 2) {
	          localStorage.setItem('role', result.role);
	        }
	
	        if (result.status !== 1) {
	          alert('Greska. Skin je vec obrisan');
	        }
	      }, function (reason) {});
	    }
	  },
	  updated: function updated() {
	    var self = this;
	
	    $(window).scroll(function (event) {
	      if (self.scrollCalled === 0) {
	        if ($(this).scrollTop() + $(this).innerHeight() >= $('body')[0].scrollHeight) {
	          if (self.skinSearch.length < 3) {
	            self.scrollCalled = 1;
	            self.getSkinsDBNext();
	          }
	        }
	      }
	    });
	  },
	
	  created: function created() {
	    if (screen.width > 1500) {
	      this.bigScreenSkins = 2;
	    }
	    this.getSkinsDB();
	    this.role = this.$store.state.role;
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'Waiting',
	
	  data: function data() {
	    return {
	      baseUrl2: 'https://agar.rs',
	      loading: true,
	      rename: false,
	      skins: new Form({
	        images: [],
	        visible_images: [],
	        skin_name: ''
	      }),
	      skinSearch: '',
	      isActiveSearch: false,
	      scrollCalled: 0,
	      isLoadingNew: false,
	      role: 1,
	      bigScreenSkins: 3
	
	    };
	  },
	  methods: {
	    getSkinsDB: function getSkinsDB() {
	      var self = this;
	      this.skins.post(baseUrl + 'Skins/getWaitingSkinList').then(function (result) {
	        self.skins.images = result.list;
	        self.skins.visible_images = result.list;
	        self.$store.commit('SET_SKINS', Number(result.list.length));
	        self.loading = false;
	      }, function (reason) {});
	    },
	    skinSearchDB: function skinSearchDB() {
	      var self = this;
	      if (this.skinSearch.length === 0) {
	        this.skins.visible_images = this.skins.images.slice();
	      }
	      if (this.skinSearch.length > 2) {
	        this.isActiveSearch = true;
	        var data = {};
	        data['term'] = this.skinSearch;
	        this.skins.visible_images = [];
	        this.skins.post(baseUrl + 'Skins/searchSkin', data).then(function (result) {
	          if (result.status === 1) {
	            self.skins.visible_images = result.list.slice();
	            self.isActiveSearch = false;
	          }
	        }, function (reason) {});
	      }
	    },
	
	    renameSkinDB: function renameSkinDB(oldname, meta) {
	      var name = $(meta).prev('input').val();
	      var data = {
	        'user_id': localStorage.user_id,
	        'token_header': localStorage.token_header,
	        'token_log': localStorage.token_log,
	        'name': name,
	        'oldname': oldname
	      };
	
	      this.skins.post(baseUrl + 'Skins/renameSkin', data).then(function (result) {
	        if (result.status === 1) {}
	
	        if (result.status !== 1) {
	          alert('Greska. Ime verovatno postoji. Probaj drugo ime');
	        }
	      }, function (reason) {});
	    },
	
	    removeSkinDB: function removeSkinDB(item, name) {
	      var self = this;
	      var data = {
	        'id': item,
	        'name': name
	      };
	      console.log(data);
	      this.skins.post(baseUrl + 'Skins/declineSkin', data).then(function (result) {
	        if (result.status === 1) {
	          self.skins.visible_images.find(function (o, i) {
	            if (o.skin_name === name) {
	              if (i >= 0) {
	                self.skins.visible_images.splice(i, 1);
	                self.$store.commit('SET_SKINS', self.$store.state.waitSkins - 1);
	                return 0;
	              }
	            }
	          });
	        } else {
	          alert('Skin je vec obrisan');
	        }
	      }, function (reason) {});
	    },
	    approveSkin: function approveSkin(item) {
	      var self = this;
	      var data = {
	        'by': localStorage.user_id,
	
	        'name': item
	      };
	      this.skins.post(baseUrl + 'Skins/acceptSkin', data).then(function (result) {
	        if (result.status === 1) {
	          self.skins.visible_images.find(function (o, i) {
	            if (o.skin_name === item) {
	              if (i >= 0) {
	                self.skins.visible_images.splice(i, 1);
	                self.$store.commit('SET_SKINS', self.$store.state.waitSkins - 1);
	                return 0;
	              }
	            }
	          });
	        } else {
	          alert('Skin sa tim imenom vec postoji. Promeni ime skina');
	        }
	      }, function (reason) {});
	    }
	  },
	  updated: function updated() {},
	
	  created: function created() {
	    if (screen.width > 1500) {
	      this.bigScreenSkins = 2;
	    }
	    this.getSkinsDB();
	    this.role = this.$store.state.role;
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(194);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'allInfo',
	
	  data: function data() {
	    return {
	      form: new Form({}),
	      data: {
	        nicknames: [],
	        allIp: []
	      },
	      ip: {
	        address: ''
	      },
	      userInfo: {
	        id: 0,
	        skins: []
	      },
	      role: 0,
	      term: '',
	      type: 'nickname',
	      error: ''
	    };
	  },
	  computed: {},
	  methods: {
	    testUri: function testUri(arg) {
	      var valu = '';
	      try {
	        valu = decodeURI(arg);
	      } catch (err) {
	        valu = arg;
	        console.log('greska');
	      }
	      return valu;
	    },
	    aboutUser: function aboutUser() {
	      var _this = this;
	
	      $('#myModal').modal('show');
	      this.form.post(baseUrl + 'Admin/getUserPrivateSkins/' + this.userInfo['id']).then(function (result) {
	        if (result.status === 1) {
	          _this.userInfo.skins = result.list;
	        }
	      }, function (reason) {});
	    },
	    getIpInfo: function getIpInfo(ip) {
	      var _this2 = this;
	
	      this.form.post('https://ipapi.co/' + ip + '/json/', {}).then(function (result) {
	        _this2.ip['address'] = ip;
	        _this2.ip['city'] = result['city'] + ' / ' + result['region'] + ' / ' + result['postal'];
	        _this2.ip['country'] = result['country_name'];
	        _this2.ip['region'] = result['region'];
	        _this2.ip['isp'] = result['org'];
	      }, function (reason) {});
	    },
	    searchUser: function searchUser() {
	      var _this3 = this;
	
	      var data = {
	        'token_header': localStorage.token_header,
	        'token_log': localStorage.token_log
	      };
	      this.error = '';
	      var searchTerm = this.term;
	      if (this.type === 'nickname') {
	        searchTerm = encodeURI(this.term);
	        data['nickname'] = searchTerm;
	      } else {
	        data['ip'] = this.term;
	      }
	      this.data = {
	        nicknames: [],
	        allIp: []
	      };
	      this.form.post(baseUrl + 'Admin/allUserInfo', data).then(function (result) {
	        if (result.status === 1) {
	          _this3.data.nicknames = result.data.nicknames;
	          _this3.data.allIp = result.data.all_ip;
	          _this3.userInfo.id = Number(result.data.user_id);
	        }
	      }, function (reason) {
	        _this3.error = (0, _stringify2.default)(reason);
	      });
	    },
	    copyNick: function copyNick(nick) {
	      this.ip['address'] = '';
	      this.type = 'nickname';
	      this.term = this.testUri(nick);
	    },
	    copyIP: function copyIP(ip) {
	      this.type = 'ip';
	      this.term = ip;
	      this.getIpInfo(ip);
	    }
	  },
	  mounted: function mounted() {
	    this.role = Number(this.$store.state.role);
	    if (Number(this.$store.state.role) < 40) {
	      this.$router.push('/dashboard');
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'Users',
	
	  data: function data() {
	    return {
	      form: new Form({}),
	      users: [],
	      number_of_users: 0,
	      first_users: [],
	      paginated: [],
	      userInfo: {
	        id: 0,
	        skins: []
	      },
	      users_per_page: 100,
	      role: 0,
	      group: 0,
	      search: '',
	      searchName: '',
	      currentPage: 1,
	      term: '',
	      type: 'nickname'
	    };
	  },
	  computed: {
	    numberOfPages: function numberOfPages() {
	      var q = this.number_of_users / this.users_per_page;
	      if (this.number_of_users % this.users_per_page === 0) {
	        return ~~q;
	      }
	      return ~~q + 1;
	    },
	    visiblePaginated: function visiblePaginated() {
	      var array = [];
	      var i = this.currentPage > 1 ? this.currentPage * this.users_per_page - this.users_per_page : 0;
	      for (i; i < this.currentPage * this.users_per_page; i++) {
	        if (this.visible[i] !== undefined) {
	          array.push(this.visible[i]);
	        }
	      }
	      return array;
	    },
	    visible: function visible(value) {
	      var self = this;
	      if (this.search !== '') {
	        return this.users.filter(function (user) {
	          return user.nickname !== null && user.nickname.indexOf(encodeURI(self.search)) !== -1;
	        });
	      }
	      if (this.searchName !== '') {
	        return this.users.filter(function (user) {
	          var fullname = (user.firstname + ' ' + user.lastname + ' ' + user.email).toLowerCase();
	          return fullname.indexOf(self.searchName.toLowerCase()) !== -1;
	        });
	      }
	      if (this.group === 0) {
	        return this.users;
	      } else if (this.group === 1) {
	        return this.users.filter(function (user) {
	          return user.facebook_id != null;
	        });
	      } else {
	        return this.users.filter(function (user) {
	          return user.facebook_id == null;
	        });
	      }
	    }
	  },
	  methods: {
	    fetchUsers: function fetchUsers(position) {
	      var _this = this;
	
	      var data = {
	        'position': position,
	        'user_id': localStorage.user_id,
	        'token_header': localStorage.token_header,
	        'token_log': localStorage.token_log
	      };
	      this.form.post(baseUrl + 'Admin/getAllUsers', data).then(function (result) {
	        if (result.status === 1) {
	          _this.users = result.list;
	          _this.first_users = _this.users;
	        }
	      }, function (reason) {});
	    },
	    changePage: function changePage(page) {
	      this.currentPage = page;
	      if (this.users.length) {
	        var lastUserId = this.users[this.users.length - 1].id;
	        this.users = [];
	        this.fetchUsers(lastUserId);
	      }
	    },
	    changeGroup: function changeGroup(id) {
	      this.group = id;
	    },
	    testUri: function testUri(arg) {
	      var valu = '';
	      try {
	        valu = decodeURI(arg);
	      } catch (err) {
	        valu = arg;
	        console.log('greska');
	      }
	      return valu;
	    },
	    deleteUser: function deleteUser(id) {
	      var self = this;
	      var data = {
	        'token_header': localStorage.token_header,
	        'token_log': localStorage.token_log,
	        'id': id
	      };
	      this.form.post(baseUrl + 'Admin/deleteUsserss', data).then(function (result) {
	        if (result.status === 1) {
	          self.users.find(function (o, i) {
	            if (Number(o.id) === Number(id)) {
	              if (i >= 0) {
	                self.users.splice(i, 1);
	                return 0;
	              }
	            }
	          });
	        }
	      }, function (reason) {});
	    },
	
	    aboutUser: function aboutUser(user) {
	      var self = this;
	      this.userInfo['id'] = user.id;
	      this.userInfo['nickname'] = user.nickname;
	      this.userInfo['email'] = user.email;
	      this.userInfo['firstname'] = user.firstname;
	      this.userInfo['lastname'] = user.lastname;
	      this.userInfo['facebook_id'] = user.facebook_id;
	      this.userInfo['age_range'] = user.age_range;
	      this.userInfo['password_view'] = user.password_view;
	      this.userInfo['color'] = user.color;
	      this.userInfo['coins'] = user.coins;
	      $('#myModal').modal('show');
	      this.form.post(baseUrl + 'Admin/getUserPrivateSkins/' + user.id).then(function (result) {
	        if (result.status === 1) {
	          self.userInfo.skins = result.list;
	        }
	      }, function (reason) {});
	    },
	    changeNick: function changeNick(e) {
	      var nickname = $(e.target).find('.user-nickname').val();
	      var id = $(e.target).find('.user-id').val();
	      var data = {
	        'name': encodeURI(nickname),
	        'id': id,
	        'token_header': localStorage.getItem('token_header'),
	        'token_log': localStorage.getItem('token_log')
	      };
	      this.form.post(baseUrl + 'Admin/renameUser', data).then(function (result) {
	        alert(result.msg);
	      }, function (reason) {});
	    },
	
	    searchUser: function searchUser() {
	      var self = this;
	
	      var searchTerm = this.term;
	      if (this.type === 'nickname') {
	        searchTerm = encodeURI(this.term);
	      }
	      var data = {
	        'term': searchTerm,
	        'by': this.type,
	        'user_id': localStorage.user_id,
	        'token_header': localStorage.token_header,
	        'token_log': localStorage.token_log
	      };
	      if (this.term.length > 2 || this.type === 'id' || this.type === 'color') {
	        if (this.type === 'color') {
	          data.term = searchTerm === '' ? null : searchTerm;
	        }
	        self.users = [];
	        this.form.post(baseUrl + 'Admin/searchUser', data).then(function (result) {
	          if (result.status === 1) {
	            self.users = result.list;
	          }
	        }, function (reason) {});
	      }
	    },
	    removePrivateSkinDB: function removePrivateSkinDB(id, name) {
	      var self = this;
	      var data = {
	        'user_id': localStorage.user_id,
	        'token_header': localStorage.token_header,
	        'token_log': localStorage.token_log,
	        'name': name,
	        'id': id
	      };
	      this.form.post(baseUrl + 'Skins/removePrivateSkin', data).then(function (result) {
	        if (result.status === 1) {
	          self.userInfo.skins.find(function (o, i) {
	            if (o.skin_name === data.name) {
	              if (i >= 0) {
	                self.userInfo.skins.splice(i, 1);
	                return 0;
	              }
	            }
	          });
	        }
	        if (result.status === 2) {
	          localStorage.setItem('role', result.role);
	        }
	
	        if (result.status !== 1) {
	          alert('Greska. Skin je vec obrisan');
	        }
	      }, function (reason) {});
	    }
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    this.role = Number(this.$store.state.role);
	    if (Number(this.$store.state.role) < 33) {
	      this.$router.push('/dashboard');
	    }
	    this.form.post(baseUrl + 'Admin/agarStructure').then(function (result) {
	      _this2.number_of_users = result.info.number_of_users;
	      _this2.fetchUsers(null);
	    }, function (reason) {});
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 189 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'FBUsers',
	
	  data: function data() {
	    return {
	      form: new Form({}),
	      fb_users: [],
	      fb_selected: -1,
	      fb_selected_2: -1,
	      first_selected: {},
	      second_selected: {},
	      role: 0
	    };
	  },
	  methods: {
	    fetchFBUsers: function fetchFBUsers() {
	      var self = this;
	      this.form.post(baseUrl + 'Admin/getAllFBUsers').then(function (result) {
	        if (result.status === 1) {
	          self.fb_users = result.list;
	        }
	      }, function (reason) {});
	    },
	    testUri: function testUri(arg) {
	      var valu = '';
	      try {
	        valu = decodeURI(arg);
	      } catch (err) {
	        valu = arg;
	        console.log('greska');
	      }
	      return valu;
	    },
	    mergeAccounts: function mergeAccounts() {
	      var first = this.fb_users[this.fb_selected];
	      var second = this.fb_users[this.fb_selected_2];
	      var data = {
	        'facebook_id_first': first.facebook_id,
	        'facebook_id_second': second.facebook_id,
	        'id_one': first.id,
	        'id_two': second.id
	      };
	      this.form.post(baseUrl + 'Admin/facebookMerge', data).then(function (result) {
	        if (result.status === 1) {
	          window.location.reload();
	        }
	      }, function (reason) {});
	    }
	  },
	  mounted: function mounted() {
	    this.role = Number(this.$store.state.role);
	    if (Number(this.$store.state.role) < 33) {
	      this.$router.push('/dashboard');
	    }
	    this.fetchFBUsers();
	  }
	};

/***/ }),
/* 190 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'ControlSidebar'
	};

/***/ }),
/* 191 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'DashboardFooter'
	};

/***/ }),
/* 192 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'DashboardHeader',
	  data: function data() {
	    return {
	      form: new Form({}),
	      nickname: ''
	    };
	  },
	  methods: {
	    logout: function logout() {
	      var data = {
	        'user_id': localStorage.user_id,
	        'token_header': localStorage.token_header,
	        'token_log': localStorage.token_log
	      };
	      this.form.post(baseUrl + 'Home/Logout', data).then(function (result) {}, function (reason) {});
	
	      this.$store.commit('REMOVE_TOKEN');
	
	      if (window.localStorage) {
	        window.localStorage.removeItem('token_log');
	        window.localStorage.removeItem('token_header');
	        window.localStorage.removeItem('role');
	        window.localStorage.removeItem('user_id');
	      }
	
	      this.$router.push('/login');
	    }
	  },
	  mounted: function mounted() {
	    var self = this;
	    this.nickname = this.$store.state.nickname;
	    setTimeout(function () {
	      self.nickname = self.$store.state.nickname;
	    }, 500);
	  }
	};

/***/ }),
/* 193 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'DashboardSidebar',
	  data: function data() {
	    return {
	      form: new Form({}),
	      fullAdmin: 0
	    };
	  },
	  mounted: function mounted() {
	    this.fullAdmin = Number(this.$store.state.role);
	    var self = this;
	    this.form.post(baseUrl + 'Skins/numberOfWaitingSkins').then(function (result) {
	      self.$store.commit('SET_SKINS', Number(result));
	    }, function (reason) {});
	    this.form.post(baseUrl + 'Skins/numberOfWaitingPrivateSkins').then(function (result) {
	      self.$store.commit('SET_PRIVATE_SKINS', Number(result));
	    }, function (reason) {});
	  }
	};

/***/ }),
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 256 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 257 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 258 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 259 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 260 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 261 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 262 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 263 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 264 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 265 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 266 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 267 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 268 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 269 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 270 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 271 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 272 */,
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 44,
		"./af.js": 44,
		"./ar": 51,
		"./ar-dz": 45,
		"./ar-dz.js": 45,
		"./ar-kw": 46,
		"./ar-kw.js": 46,
		"./ar-ly": 47,
		"./ar-ly.js": 47,
		"./ar-ma": 48,
		"./ar-ma.js": 48,
		"./ar-sa": 49,
		"./ar-sa.js": 49,
		"./ar-tn": 50,
		"./ar-tn.js": 50,
		"./ar.js": 51,
		"./az": 52,
		"./az.js": 52,
		"./be": 53,
		"./be.js": 53,
		"./bg": 54,
		"./bg.js": 54,
		"./bn": 55,
		"./bn.js": 55,
		"./bo": 56,
		"./bo.js": 56,
		"./br": 57,
		"./br.js": 57,
		"./bs": 58,
		"./bs.js": 58,
		"./ca": 59,
		"./ca.js": 59,
		"./cs": 60,
		"./cs.js": 60,
		"./cv": 61,
		"./cv.js": 61,
		"./cy": 62,
		"./cy.js": 62,
		"./da": 63,
		"./da.js": 63,
		"./de": 66,
		"./de-at": 64,
		"./de-at.js": 64,
		"./de-ch": 65,
		"./de-ch.js": 65,
		"./de.js": 66,
		"./dv": 67,
		"./dv.js": 67,
		"./el": 68,
		"./el.js": 68,
		"./en-au": 69,
		"./en-au.js": 69,
		"./en-ca": 70,
		"./en-ca.js": 70,
		"./en-gb": 71,
		"./en-gb.js": 71,
		"./en-ie": 72,
		"./en-ie.js": 72,
		"./en-nz": 73,
		"./en-nz.js": 73,
		"./eo": 74,
		"./eo.js": 74,
		"./es": 76,
		"./es-do": 75,
		"./es-do.js": 75,
		"./es.js": 76,
		"./et": 77,
		"./et.js": 77,
		"./eu": 78,
		"./eu.js": 78,
		"./fa": 79,
		"./fa.js": 79,
		"./fi": 80,
		"./fi.js": 80,
		"./fo": 81,
		"./fo.js": 81,
		"./fr": 84,
		"./fr-ca": 82,
		"./fr-ca.js": 82,
		"./fr-ch": 83,
		"./fr-ch.js": 83,
		"./fr.js": 84,
		"./fy": 85,
		"./fy.js": 85,
		"./gd": 86,
		"./gd.js": 86,
		"./gl": 87,
		"./gl.js": 87,
		"./gom-latn": 88,
		"./gom-latn.js": 88,
		"./he": 89,
		"./he.js": 89,
		"./hi": 90,
		"./hi.js": 90,
		"./hr": 91,
		"./hr.js": 91,
		"./hu": 92,
		"./hu.js": 92,
		"./hy-am": 93,
		"./hy-am.js": 93,
		"./id": 94,
		"./id.js": 94,
		"./is": 95,
		"./is.js": 95,
		"./it": 96,
		"./it.js": 96,
		"./ja": 97,
		"./ja.js": 97,
		"./jv": 98,
		"./jv.js": 98,
		"./ka": 99,
		"./ka.js": 99,
		"./kk": 100,
		"./kk.js": 100,
		"./km": 101,
		"./km.js": 101,
		"./kn": 102,
		"./kn.js": 102,
		"./ko": 103,
		"./ko.js": 103,
		"./ky": 104,
		"./ky.js": 104,
		"./lb": 105,
		"./lb.js": 105,
		"./lo": 106,
		"./lo.js": 106,
		"./lt": 107,
		"./lt.js": 107,
		"./lv": 108,
		"./lv.js": 108,
		"./me": 109,
		"./me.js": 109,
		"./mi": 110,
		"./mi.js": 110,
		"./mk": 111,
		"./mk.js": 111,
		"./ml": 112,
		"./ml.js": 112,
		"./mr": 113,
		"./mr.js": 113,
		"./ms": 115,
		"./ms-my": 114,
		"./ms-my.js": 114,
		"./ms.js": 115,
		"./my": 116,
		"./my.js": 116,
		"./nb": 117,
		"./nb.js": 117,
		"./ne": 118,
		"./ne.js": 118,
		"./nl": 120,
		"./nl-be": 119,
		"./nl-be.js": 119,
		"./nl.js": 120,
		"./nn": 121,
		"./nn.js": 121,
		"./pa-in": 122,
		"./pa-in.js": 122,
		"./pl": 123,
		"./pl.js": 123,
		"./pt": 125,
		"./pt-br": 124,
		"./pt-br.js": 124,
		"./pt.js": 125,
		"./ro": 126,
		"./ro.js": 126,
		"./ru": 127,
		"./ru.js": 127,
		"./sd": 128,
		"./sd.js": 128,
		"./se": 129,
		"./se.js": 129,
		"./si": 130,
		"./si.js": 130,
		"./sk": 131,
		"./sk.js": 131,
		"./sl": 132,
		"./sl.js": 132,
		"./sq": 133,
		"./sq.js": 133,
		"./sr": 135,
		"./sr-cyrl": 134,
		"./sr-cyrl.js": 134,
		"./sr.js": 135,
		"./ss": 136,
		"./ss.js": 136,
		"./sv": 137,
		"./sv.js": 137,
		"./sw": 138,
		"./sw.js": 138,
		"./ta": 139,
		"./ta.js": 139,
		"./te": 140,
		"./te.js": 140,
		"./tet": 141,
		"./tet.js": 141,
		"./th": 142,
		"./th.js": 142,
		"./tl-ph": 143,
		"./tl-ph.js": 143,
		"./tlh": 144,
		"./tlh.js": 144,
		"./tr": 145,
		"./tr.js": 145,
		"./tzl": 146,
		"./tzl.js": 146,
		"./tzm": 148,
		"./tzm-latn": 147,
		"./tzm-latn.js": 147,
		"./tzm.js": 148,
		"./uk": 149,
		"./uk.js": 149,
		"./ur": 150,
		"./ur.js": 150,
		"./uz": 152,
		"./uz-latn": 151,
		"./uz-latn.js": 151,
		"./uz.js": 152,
		"./vi": 153,
		"./vi.js": 153,
		"./x-pseudo": 154,
		"./x-pseudo.js": 154,
		"./yo": 155,
		"./yo.js": 155,
		"./zh-cn": 156,
		"./zh-cn.js": 156,
		"./zh-hk": 157,
		"./zh-hk.js": 157,
		"./zh-tw": 158,
		"./zh-tw.js": 158
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 273;


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(167)
	
	/* template */
	var __vue_template__ = __webpack_require__(310)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(269)
	
	/* script */
	__vue_exports__ = __webpack_require__(168)
	
	/* template */
	var __vue_template__ = __webpack_require__(324)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(169)
	
	/* template */
	var __vue_template__ = __webpack_require__(316)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(265)
	
	/* script */
	__vue_exports__ = __webpack_require__(170)
	
	/* template */
	var __vue_template__ = __webpack_require__(317)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7dc8860e"
	
	module.exports = __vue_exports__


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(255)
	
	/* script */
	__vue_exports__ = __webpack_require__(171)
	
	/* template */
	var __vue_template__ = __webpack_require__(301)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(172)
	
	/* template */
	var __vue_template__ = __webpack_require__(319)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(267)
	
	/* script */
	__vue_exports__ = __webpack_require__(173)
	
	/* template */
	var __vue_template__ = __webpack_require__(321)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-a015beac"
	
	module.exports = __vue_exports__


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(257)
	
	/* script */
	__vue_exports__ = __webpack_require__(174)
	
	/* template */
	var __vue_template__ = __webpack_require__(303)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-0fbd5aa2"
	
	module.exports = __vue_exports__


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(266)
	
	/* script */
	__vue_exports__ = __webpack_require__(175)
	
	/* template */
	var __vue_template__ = __webpack_require__(318)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7e85ccad"
	
	module.exports = __vue_exports__


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(176)
	
	/* template */
	var __vue_template__ = __webpack_require__(304)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(177)
	
	/* template */
	var __vue_template__ = __webpack_require__(315)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(178)
	
	/* template */
	var __vue_template__ = __webpack_require__(320)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(263)
	
	/* script */
	__vue_exports__ = __webpack_require__(179)
	
	/* template */
	var __vue_template__ = __webpack_require__(312)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5bca5a62"
	
	module.exports = __vue_exports__


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(261)
	
	/* script */
	__vue_exports__ = __webpack_require__(180)
	
	/* template */
	var __vue_template__ = __webpack_require__(309)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5671db48"
	
	module.exports = __vue_exports__


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(270)
	
	/* script */
	__vue_exports__ = __webpack_require__(181)
	
	/* template */
	var __vue_template__ = __webpack_require__(325)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-ec163aec"
	
	module.exports = __vue_exports__


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(256)
	
	/* script */
	__vue_exports__ = __webpack_require__(182)
	
	/* template */
	var __vue_template__ = __webpack_require__(302)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(262)
	
	/* script */
	__vue_exports__ = __webpack_require__(183)
	
	/* template */
	var __vue_template__ = __webpack_require__(311)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-587dd02d"
	
	module.exports = __vue_exports__


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(264)
	
	/* script */
	__vue_exports__ = __webpack_require__(184)
	
	/* template */
	var __vue_template__ = __webpack_require__(313)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(268)
	
	/* script */
	__vue_exports__ = __webpack_require__(185)
	
	/* template */
	var __vue_template__ = __webpack_require__(323)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(260)
	
	/* script */
	__vue_exports__ = __webpack_require__(186)
	
	/* template */
	var __vue_template__ = __webpack_require__(308)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-325591e3"
	
	module.exports = __vue_exports__


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(271)
	
	/* script */
	__vue_exports__ = __webpack_require__(187)
	
	/* template */
	var __vue_template__ = __webpack_require__(326)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(259)
	
	/* script */
	__vue_exports__ = __webpack_require__(188)
	
	/* template */
	var __vue_template__ = __webpack_require__(307)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(189)
	
	/* template */
	var __vue_template__ = __webpack_require__(327)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(190)
	
	/* template */
	var __vue_template__ = __webpack_require__(305)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(191)
	
	/* template */
	var __vue_template__ = __webpack_require__(314)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(192)
	
	/* template */
	var __vue_template__ = __webpack_require__(322)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(258)
	
	/* script */
	__vue_exports__ = __webpack_require__(193)
	
	/* template */
	var __vue_template__ = __webpack_require__(306)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 301 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_vm._m(0), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "form-inline"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.ip),
	      expression: "ip"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "placeholder": "IP adresa"
	    },
	    domProps: {
	      "value": (_vm.ip)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.ip = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.nickname),
	      expression: "nickname"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "placeholder": "Nickname"
	    },
	    domProps: {
	      "value": (_vm.nickname)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.nickname = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.server),
	      expression: "server"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "select-server"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.server = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [(_vm.role >= 33) ? _c('option', {
	    attrs: {
	      "value": ""
	    }
	  }, [_vm._v("Server: Svi")]) : _vm._e(), _vm._v(" "), (_vm.role >= 33 || _vm.role == 21) ? _c('option', {
	    attrs: {
	      "value": "StartGame FFA#1"
	    }
	  }, [_vm._v("StartGame FFA#1")]) : _vm._e(), _vm._v(" "), (_vm.role >= 33 || _vm.role == 21) ? _c('option', {
	    attrs: {
	      "value": "Spec FFA#1"
	    }
	  }, [_vm._v("Spec FFA#1")]) : _vm._e(), _vm._v(" "), (_vm.role >= 33 || _vm.role == 22) ? _c('option', {
	    attrs: {
	      "value": "StartGame MINIONS#2"
	    }
	  }, [_vm._v("StartGame MINIONS#2")]) : _vm._e(), _vm._v(" "), (_vm.role >= 33 || _vm.role == 22) ? _c('option', {
	    attrs: {
	      "value": "Spec MINIONS#2"
	    }
	  }, [_vm._v("Spec MINIONS#2")]) : _vm._e(), _vm._v(" "), (_vm.role >= 33 || _vm.role == 23) ? _c('option', {
	    attrs: {
	      "value": "StartGame INSTANT MERGE#3"
	    }
	  }, [_vm._v("StartGame INSTANT MERGE#3")]) : _vm._e(), _vm._v(" "), (_vm.role >= 33 || _vm.role == 23) ? _c('option', {
	    attrs: {
	      "value": "Spec INSTANT MERGE#3"
	    }
	  }, [_vm._v("Spec INSTANT MERGE#3")]) : _vm._e(), _vm._v(" "), (_vm.role >= 33 || _vm.role == 24) ? _c('option', {
	    attrs: {
	      "value": "StartGame MEGA SPLIT#4"
	    }
	  }, [_vm._v("StartGame MEGA SPLIT#4")]) : _vm._e(), _vm._v(" "), (_vm.role >= 33 || _vm.role == 24) ? _c('option', {
	    attrs: {
	      "value": "Spec MEGA SPLIT#4"
	    }
	  }, [_vm._v("Spec MEGA SPLIT#4")]) : _vm._e(), _vm._v(" "), (_vm.role >= 33 || _vm.role == 25) ? _c('option', {
	    attrs: {
	      "value": "StartGame EXPERIMENTAL#5"
	    }
	  }, [_vm._v("StartGame EXPERIMENTAL#5")]) : _vm._e(), _vm._v(" "), (_vm.role >= 33 || _vm.role == 25) ? _c('option', {
	    attrs: {
	      "value": "Spec EXPERIMENTAL#5"
	    }
	  }, [_vm._v("Spec EXPERIMENTAL#5")]) : _vm._e(), _vm._v(" "), (_vm.role >= 33 || _vm.role == 26) ? _c('option', {
	    attrs: {
	      "value": "StartGame RAINBOW#6"
	    }
	  }, [_vm._v("StartGame RAINBOW#6")]) : _vm._e(), _vm._v(" "), (_vm.role >= 33 || _vm.role == 26) ? _c('option', {
	    attrs: {
	      "value": "Spec RAINBOW#6"
	    }
	  }, [_vm._v("Spec RAINBOW#6")]) : _vm._e(), _vm._v(" "), (_vm.role >= 33 || _vm.role == 27) ? _c('option', {
	    attrs: {
	      "value": "StartGame VIRUS MINES#7"
	    }
	  }, [_vm._v("StartGame VIRUS MINES#7")]) : _vm._e(), _vm._v(" "), (_vm.role >= 33 || _vm.role == 27) ? _c('option', {
	    attrs: {
	      "value": "Spec VIRUS MINES#7"
	    }
	  }, [_vm._v("Spec VIRUS MINES#7")]) : _vm._e(), _vm._v(" "), (_vm.role >= 33 || _vm.role == 28) ? _c('option', {
	    attrs: {
	      "value": "StartGame OLD EXP#8"
	    }
	  }, [_vm._v("StartGame OLD EXP#8")]) : _vm._e(), _vm._v(" "), (_vm.role >= 33 || _vm.role == 28) ? _c('option', {
	    attrs: {
	      "value": "Spec OLD EXP#8"
	    }
	  }, [_vm._v("Spec OLD EXP#8")]) : _vm._e(), _vm._v(" "), (_vm.role >= 33 || _vm.role == 29) ? _c('option', {
	    attrs: {
	      "value": "StartGame TOURNAMENT#9"
	    }
	  }, [_vm._v("StartGame TOURNAMENT#9")]) : _vm._e(), _vm._v(" "), (_vm.role >= 33 || _vm.role == 29) ? _c('option', {
	    attrs: {
	      "value": "Spec TOURNAMENT#9"
	    }
	  }, [_vm._v("Spec TOURNAMENT#9")]) : _vm._e(), _vm._v(" "), (_vm.role >= 33 || _vm.role == 29) ? _c('option', {
	    attrs: {
	      "value": "StartGame TOURNAMENT#10"
	    }
	  }, [_vm._v("StartGame TOURNAMENT#10")]) : _vm._e(), _vm._v(" "), (_vm.role >= 33 || _vm.role == 29) ? _c('option', {
	    attrs: {
	      "value": "Spec TOURNAMENT#10"
	    }
	  }, [_vm._v("Spec TOURNAMENT#10")]) : _vm._e()]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.resolution),
	      expression: "resolution"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "resolution",
	      "placeholder": "Rezolucija npr: 1000x600"
	    },
	    domProps: {
	      "value": (_vm.resolution)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.resolution = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "button",
	      "id": "browser"
	    },
	    on: {
	      "click": function($event) {
	        _vm.browserToggleClick()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.browserToggle()))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "form-inline"
	  }, [_c('label', [_vm._v("Početni datum")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.start),
	      expression: "start"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "date"
	    },
	    domProps: {
	      "value": (_vm.start)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.start = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticStyle: {
	      "margin-left": "15px"
	    }
	  }, [_vm._v("Završni datum")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.end),
	      expression: "end"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "date",
	      "id": "endDate"
	    },
	    domProps: {
	      "value": (_vm.end)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.end = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticStyle: {
	      "margin-left": "15px"
	    }
	  }, [_vm._v("Vreme")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.hours),
	      expression: "hours"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "hours",
	      "placeholder": "00"
	    },
	    domProps: {
	      "value": (_vm.hours)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.hours = $event.target.value
	      }
	    }
	  }), _vm._v(" :\n            "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.minute),
	      expression: "minute"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "minute",
	      "placeholder": "30"
	    },
	    domProps: {
	      "value": (_vm.minute)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.minute = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-danger",
	    staticStyle: {
	      "margin-left": "15px"
	    },
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.realTime()
	      }
	    }
	  }, [_vm._v("Sada")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-primary",
	    staticStyle: {
	      "margin-left": "15px"
	    },
	    attrs: {
	      "type": "button",
	      "id": "search"
	    },
	    on: {
	      "click": function($event) {
	        _vm.queryReports()
	      }
	    }
	  }, [_vm._v("Pretraži")])]), _vm._v(" "), _c('table', {
	    staticClass: "table table-striped"
	  }, [_c('thead', [_c('tr', [_c('td', [_vm._v("Server")]), _vm._v(" "), _c('td', [_vm._v("Nick")]), _vm._v(" "), _c('td', [_vm._v("IP adresa")]), _vm._v(" "), _c('td', [_vm._v("Grad/Zemlja")]), _vm._v(" "), _c('td', [_vm._v("Sistem")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.browserToggle()) + "/Rezolucija")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.result), function(col) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(col.dimensions[2]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(col.dimensions[1]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(col.dimensions[0]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(col.dimensions[3]) + ", " + _vm._s(col.dimensions[4]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(col.dimensions[5]) + ", " + _vm._s(col.dimensions[6]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(col.dimensions[7]) + " / " + _vm._s(col.dimensions[8]))])])
	  }))])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("\n            Google analitika\n            "), _c('small', [_c('p', {
	    staticClass: "g-signin2",
	    staticStyle: {
	      "display": "inline"
	    },
	    attrs: {
	      "data-onsuccess": "queryReports"
	    }
	  })])])])
	}]}

/***/ }),
/* 302 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_vm._m(0), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('form', {
	    staticClass: "col-sm-6"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.skinSearch),
	      expression: "skinSearch"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "Search..."
	    },
	    domProps: {
	      "value": (_vm.skinSearch)
	    },
	    on: {
	      "keyup": function($event) {
	        _vm.skinSearchDB();
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.skinSearch = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-offset-1 col-sm-3"
	  }, [_c('a', {
	    staticClass: "rename-skins btn btn-danger",
	    on: {
	      "click": function($event) {
	        _vm.rename = !_vm.rename
	      }
	    }
	  }, [_c('i', {
	    staticClass: "edit icon"
	  }), _vm._v("Change skins name")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [(_vm.skins.images.length) ? _c('div', {
	    staticClass: "ui six stackable cards",
	    attrs: {
	      "id": "skins-cards"
	    }
	  }, _vm._l((_vm.skins.visible_images), function(item) {
	    return _c('div', {
	      class: 'col-sm-6 col-md-4 card col-lg-' + _vm.bigScreenSkins,
	      attrs: {
	        "data-skin-id": item.id
	      }
	    }, [_c('img', {
	      staticClass: "card-img-top",
	      attrs: {
	        "src": _vm.baseUrl2 + '/public/images/skins/' + item.skin_name + '.png'
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "card-block"
	    }, [_c('div', {
	      staticClass: "card-text"
	    }, [(_vm.role >= 33) ? _c('span', [_vm._v(_vm._s(item.ip))]) : _vm._e(), _vm._v(" "), (_vm.role >= 33) ? _c('span', {
	      staticClass: "pull-right"
	    }, [_vm._v(_vm._s(item.approved_by))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	      staticClass: "card-footer"
	    }, [(!_vm.rename) ? _c('h4', {
	      staticClass: "text-center card-title mt-3"
	    }, [_vm._v(_vm._s(item.skin_name))]) : _c('div', {
	      staticClass: "ui bottom attached button chose-skin edit-name"
	    }, [_c('div', {
	      staticClass: "input-group"
	    }, [_c('input', {
	      staticClass: "form-control",
	      attrs: {
	        "type": "text"
	      },
	      domProps: {
	        "value": item.skin_name
	      }
	    }), _vm._v(" "), _c('span', {
	      staticClass: "input-group-addon",
	      on: {
	        "click": function($event) {
	          _vm.renameSkinDB(item.skin_name, $event.target)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-floppy-o",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    })])])]), _vm._v(" "), _c('button', {
	      staticClass: "btn btn-danger btn-sm",
	      on: {
	        "click": function($event) {
	          _vm.removeSkinDB(item.id, item.skin_name)
	        }
	      }
	    }, [_vm._v("Delete")]), _vm._v(" "), (Number(item.safe)) ? _c('button', {
	      staticClass: "btn btn-success pull-right btn-sm",
	      on: {
	        "click": function($event) {
	          _vm.safeSkin(item.id, item.skin_name, 0)
	        }
	      }
	    }, [_vm._v("Siguran skin")]) : _vm._e(), _vm._v(" "), (!Number(item.safe)) ? _c('button', {
	      staticClass: "btn btn-warning pull-right btn-sm",
	      on: {
	        "click": function($event) {
	          _vm.safeSkin(item.id, item.skin_name, 1)
	        }
	      }
	    }, [_vm._v("Nije siguran")]) : _vm._e()])])
	  })) : _vm._e()])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("\n      Skins\n      "), _c('small', [_vm._v("Skin list")])])])
	}]}

/***/ }),
/* 303 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_vm._m(0), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    staticClass: "form"
	  }, [(_vm.role >= 33) ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.ip),
	      expression: "ip"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "placeholder": "IP adresa"
	    },
	    domProps: {
	      "value": (_vm.ip)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.ip = $event.target.value
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.nickname),
	      expression: "nickname"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "placeholder": "Nickname"
	    },
	    domProps: {
	      "value": (_vm.nickname)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.nickname = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.message),
	      expression: "message"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "placeholder": "Message.."
	    },
	    domProps: {
	      "value": (_vm.message)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.message = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.server),
	      expression: "server"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "select-server"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.server = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [(_vm.role >= 33) ? _c('option', {
	    attrs: {
	      "value": ""
	    }
	  }, [_vm._v("Server: Svi")]) : _vm._e(), _vm._v(" "), (_vm.role >= 33 || _vm.role == 21) ? _c('option', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_vm._v("FFA#1")]) : _vm._e(), _vm._v(" "), (_vm.role >= 33 || _vm.role == 22) ? _c('option', {
	    attrs: {
	      "value": "2"
	    }
	  }, [_vm._v("MINIONS#2")]) : _vm._e(), _vm._v(" "), (_vm.role >= 33 || _vm.role == 23) ? _c('option', {
	    attrs: {
	      "value": "3"
	    }
	  }, [_vm._v("INSTANT MERGE#3")]) : _vm._e(), _vm._v(" "), (_vm.role >= 33 || _vm.role == 24) ? _c('option', {
	    attrs: {
	      "value": "4"
	    }
	  }, [_vm._v("MEGA SPLIT#4")]) : _vm._e(), _vm._v(" "), (_vm.role >= 33 || _vm.role == 25) ? _c('option', {
	    attrs: {
	      "value": "5"
	    }
	  }, [_vm._v("EXPERIMENTAL#5")]) : _vm._e(), _vm._v(" "), (_vm.role >= 33 || _vm.role == 26) ? _c('option', {
	    attrs: {
	      "value": "6"
	    }
	  }, [_vm._v("RAINBOW#6")]) : _vm._e(), _vm._v(" "), (_vm.role >= 33 || _vm.role == 27) ? _c('option', {
	    attrs: {
	      "value": "7"
	    }
	  }, [_vm._v("VIRUS MINES#7")]) : _vm._e(), _vm._v(" "), (_vm.role >= 33 || _vm.role == 28) ? _c('option', {
	    attrs: {
	      "value": "8"
	    }
	  }, [_vm._v("OLD EXP#8")]) : _vm._e(), _vm._v(" "), (_vm.role >= 33 || _vm.role == 29) ? _c('option', {
	    attrs: {
	      "value": "9"
	    }
	  }, [_vm._v("TEAMS#9")]) : _vm._e(), _vm._v(" "), (_vm.role >= 33 || _vm.role == 29) ? _c('option', {
	    attrs: {
	      "value": "10"
	    }
	  }, [_vm._v("TOURNAMENT#10")]) : _vm._e()]), _vm._v(" "), (_vm.role >= 33) ? _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.client),
	      expression: "client"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "client",
	      "id": "select-client"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.client = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": ""
	    }
	  }, [_vm._v("All")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "0"
	    }
	  }, [_vm._v("Main")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_vm._v("Lite")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "2"
	    }
	  }, [_vm._v("Mobile")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "4"
	    }
	  }, [_vm._v("Facebook App")])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "clearfix"
	  }), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.msg !== ''),
	      expression: "msg !== ''"
	    }],
	    staticClass: "alert alert-danger"
	  }, [_vm._v("\n                  " + _vm._s(_vm.msg) + "\n                ")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-info btn-block",
	    on: {
	      "click": function($event) {
	        _vm.search()
	      }
	    }
	  }, [_vm._v("Pretraži")])])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr', {
	    staticStyle: {
	      "box-shadow": "1px 1px 1px gray"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "chat"
	  }, [_c('div', {
	    staticClass: "chat-title"
	  }, [_c('div', {
	    staticClass: "panel panel-default"
	  }, [_c('div', {
	    staticClass: "panel-heading"
	  }, [_vm._v("\n                        Rezultati pretrage\n                        "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.returnedDateTime != ''),
	      expression: "returnedDateTime != ''"
	    }]
	  }, [_vm._v("od: " + _vm._s(_vm.returnedDateTime))]), _vm._v(" /\n                        "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.result.length > 0),
	      expression: "result.length > 0"
	    }]
	  }, [_vm._v("Broj rezultata: " + _vm._s(_vm.result.length))]), _vm._v(" "), (_vm.role >= 40) ? _c('button', {
	    staticClass: "btn btn-info btn-sm pull-right",
	    attrs: {
	      "type": "button",
	      "data-toggle": "modal",
	      "data-target": "#myModal"
	    }
	  }, [_vm._v("Notes")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "clearfix"
	  })])])]), _vm._v(" "), (_vm.result.length > 0) ? _c('div', {
	    staticClass: "chat-box"
	  }, [_vm._l((_vm.result), function(item, index) {
	    return _c('div', {
	      class: [index % 2 == 0 ? 'even' : 'odd', 'chat-message list-group-item'],
	      attrs: {
	        "data-toggle": "tooltip",
	        "data-placement": "top",
	        "title": item.datetime + ', ' + item.server
	      },
	      on: {
	        "click": function($event) {
	          _vm.takeAction(item)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "sender"
	    }, [_vm._v(_vm._s(_vm.decoded(item.nickname)) + ": ")]), _vm._v(" "), _c('span', {
	      staticClass: "body"
	    }, [_vm._v(_vm._s(_vm.decoded(item.message)))])])
	  }), _vm._v(" "), (_vm.resultLength == 100 && !_vm.searching) ? _c('span', {
	    staticClass: "load-more",
	    on: {
	      "click": function($event) {
	        _vm.loadMore()
	      }
	    }
	  }, [_vm._v("Load more")]) : _vm._e()], 2) : _c('div', {
	    class: [_vm.searching ? 'alert-info' : 'alert-danger', ' alert']
	  }, [_c('p', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.searching),
	      expression: "!searching"
	    }]
	  }, [_vm._v("Nema rezultata pretrage.")]), _vm._v(" "), _c('p', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.searching),
	      expression: "searching"
	    }]
	  }, [_vm._v("Pretražuje se...")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (Object.keys(_vm.selectedMessage).length !== 0),
	      expression: "Object.keys(selectedMessage).length !== 0"
	    }],
	    staticClass: "box box-info"
	  }, [_vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', [_c('form', {
	    staticClass: "form-horizontal"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "col-sm-2 control-label",
	    attrs: {
	      "for": "nickname"
	    }
	  }, [_vm._v("Nick")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-10"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.ban.nickname),
	      expression: "ban.nickname"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "nickname",
	      "placeholder": "Nickname..."
	    },
	    domProps: {
	      "value": (_vm.ban.nickname)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.ban.nickname = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.role >= 33),
	      expression: "role >= 33"
	    }],
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "col-sm-2 control-label",
	    attrs: {
	      "for": "ip-address"
	    }
	  }, [_vm._v("IP")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-10"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.ban.ip),
	      expression: "ban.ip",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "ip-address",
	      "placeholder": "IP address"
	    },
	    domProps: {
	      "value": (_vm.ban.ip)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.ban.ip = $event.target.value.trim()
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  })])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "col-sm-2 control-label",
	    attrs: {
	      "for": "type"
	    }
	  }, [_vm._v("Ban type")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-10"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.ban.type),
	      expression: "ban.type"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "type"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.ban.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_vm._v("Game - preusmerava na stranu ban")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "2"
	    }
	  }, [_vm._v("Chat - gasi mu chat")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "3"
	    }
	  }, [_vm._v("Skins - zabrana dodavanja")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "4"
	    }
	  }, [_vm._v("Igra - ubija tab (oprezno)")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5"
	    }
	  }, [_vm._v("Salje mu poruku iz 'Reasona'")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "6"
	    }
	  }, [_vm._v("Protrese mu ekran svakih 20 sek. Unban da ne trese stalno.")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "col-sm-2 control-label",
	    attrs: {
	      "for": "reason"
	    }
	  }, [_vm._v("Reason")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-10"
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.ban.reason),
	      expression: "ban.reason"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "reason",
	      "rows": "2"
	    },
	    domProps: {
	      "value": (_vm.ban.reason)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.ban.reason = $event.target.value
	      }
	    }
	  })])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-footer"
	  }, [_c('div', [_c('p', {
	    staticClass: "text-danger text-left"
	  }, [_c('u', [_vm._v(_vm._s(_vm.ban.date_to != '' ? 'Banuj do: ' + ((new Date(_vm.ban.date_to)).toUTCString()) : ''))])]), _vm._v(" "), _c('p', {
	    staticClass: "text-danger text-right"
	  }, [_vm._v(_vm._s(_vm.ban.msg))]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-info pull-right",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.banPlayer()
	      }
	    }
	  }, [_vm._v("\n                    Ban\n                  ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-footer"
	  }, [_c('p', [_vm._v("Poruka: " + _vm._s(_vm.decoded(_vm.selectedMessage.message)))]), _vm._v(" "), _c('p', [_vm._v("Vreme: " + _vm._s(_vm.selectedMessage.datetime) + ", Klijent: " + _vm._s(_vm.selectedMessage.client))]), _vm._v(" "), (_vm.role >= 40) ? _c('table', {
	    staticClass: "table table-striped"
	  }, _vm._l((_vm.ipinfo), function(value, key) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(key))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(value))])])
	  })) : _vm._e()])])])]), _vm._v(" "), _c('div', {
	    staticClass: "modal fade",
	    attrs: {
	      "id": "myModal",
	      "role": "dialog"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog modal-md"
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-body"
	  }, [_c('form', [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.localStorageNicknames),
	      expression: "localStorageNicknames"
	    }],
	    staticClass: "form-control",
	    staticStyle: {
	      "min-width": "100%"
	    },
	    attrs: {
	      "rows": "6",
	      "maxlength": "5000"
	    },
	    domProps: {
	      "value": (_vm.localStorageNicknames)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.localStorageNicknames = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.saveLocalNicknames()
	      }
	    }
	  }, [_vm._v("Save")])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("\n      Chat History\n      "), _c('small', [_vm._v("Search for conversation")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    attrs: {
	      "id": "datetimepicker12"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Ban")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "col-sm-2 control-label",
	    attrs: {
	      "for": "datetimepicker"
	    }
	  }, [_vm._v("Date to")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-10"
	  }, [_c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "datetimepicker"
	    }
	  })])])
	}]}

/***/ }),
/* 304 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_vm._m(0), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    staticClass: "box box-info"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', [_c('form', {
	    staticClass: "form-horizontal"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "col-sm-2 control-label",
	    attrs: {
	      "for": "type"
	    }
	  }, [_vm._v("Pretraga po:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-10"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.type),
	      expression: "type"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "type"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "nickname",
	      "selected": ""
	    }
	  }, [_vm._v("Nickname")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "email"
	    }
	  }, [_vm._v("Email")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "id"
	    }
	  }, [_vm._v("ID")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "firstname"
	    }
	  }, [_vm._v("Ime")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "lastname"
	    }
	  }, [_vm._v("Prezime")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "col-sm-2 control-label",
	    attrs: {
	      "for": "term"
	    }
	  }, [_vm._v("Traži")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-10"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.term),
	      expression: "term"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "autocomplete": "off",
	      "type": "text",
	      "id": "term",
	      "placeholder": "Traži"
	    },
	    domProps: {
	      "value": (_vm.term)
	    },
	    on: {
	      "keyup": function($event) {
	        _vm.searchUser()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.term = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "search-results-list"
	  }, [_c('ul', {
	    staticClass: "list-group"
	  }, _vm._l((_vm.userList), function(user) {
	    return _c('li', {
	      staticClass: "list-group-item",
	      staticStyle: {
	        "cursor": "pointer"
	      },
	      on: {
	        "click": function($event) {
	          _vm.pickUser(user)
	        }
	      }
	    }, [_vm._v(_vm._s(decodeURI(user.nickname)))])
	  })), _vm._v(" "), (_vm.userList.length > 0 && _vm.selected_user == 0) ? _c('small', [_vm._v("Klikni na rezultat da odabereš igrača.")]) : _vm._e(), _vm._v(" "), (_vm.userList.length == 0 && _vm.term.length > 0) ? _c('p', [_vm._v("Nije pronađen igrač.")]) : _vm._e()])])]), _vm._v(" "), (_vm.selected_user > 0) ? _c('div', [_c('div', {
	    staticClass: "jumbotron"
	  }, [_c('p', [_vm._v("Nick: " + _vm._s(decodeURI(_vm.userInfo.nickname)))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.userInfo.email) + " " + _vm._s(_vm.userInfo.firstname) + " " + _vm._s(_vm.userInfo.lastname))]), _vm._v(" "), _c('p', [_vm._v("Coins: " + _vm._s(_vm.userInfo.coins))]), _vm._v(" "), _c('p', [_vm._v("ID: " + _vm._s(_vm.userInfo.id))]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "col-sm-2 control-label",
	    attrs: {
	      "for": "reason"
	    }
	  }, [_vm._v("Razlog")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-10"
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.reason),
	      expression: "reason"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "reason",
	      "rows": "2"
	    },
	    domProps: {
	      "value": (_vm.reason)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.reason = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "col-sm-4 control-label",
	    attrs: {
	      "for": "reason"
	    }
	  }, [_vm._v("Broj zlatnika")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.coins_number),
	      expression: "coins_number"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "number",
	      "id": "coins_number"
	    },
	    domProps: {
	      "value": (_vm.coins_number)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.coins_number = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "box-footer"
	  }, [_c('div', [_c('p', {
	    staticClass: "text-danger text-right"
	  }, [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-info pull-right",
	    attrs: {
	      "disabled": _vm.coins_number == 0,
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.addCoins()
	      }
	    }
	  }, [_vm._v("\n                        Add Coins\n                      ")])])])]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('table', {
	    staticClass: "table table-condensed table-striped"
	  }, [_vm._m(2), _vm._v(" "), (_vm.transactions.length > 0) ? _c('tbody', _vm._l((_vm.transactions), function(transaction) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(decodeURI(transaction.nickname)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(decodeURI(transaction.reason)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(transaction.coins_number))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(transaction.from_admin))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(transaction.date))])])
	  })) : _c('tbody', [_c('div', {
	    staticClass: "ui hidden divider"
	  }), _vm._v(" "), _c('h3', [_vm._v("\n            List is empty\n          ")]), _vm._v(" "), _c('div', {
	    staticClass: "ui hidden divider"
	  })])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("\n      Coins\n      "), _c('small', [_vm._v("You can add coins to users here")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Coin form")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', [_vm._v("Nick")]), _vm._v(" "), _c('th', [_vm._v("Reason")]), _vm._v(" "), _c('th', [_vm._v("Coins")]), _vm._v(" "), _c('th', [_vm._v("From")]), _vm._v(" "), _c('th', [_vm._v("Date")])])])
	}]}

/***/ }),
/* 305 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('aside', {
	    staticClass: "control-sidebar control-sidebar-dark"
	  }, [_c('div', {
	    staticClass: "tab-content"
	  }, [_c('div', {
	    staticClass: "tab-pane",
	    attrs: {
	      "id": "control-sidebar-home-tab"
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "control-sidebar-bg"
	  })])
	}]}

/***/ }),
/* 306 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('aside', {
	    staticClass: "main-sidebar"
	  }, [_c('section', {
	    staticClass: "sidebar"
	  }, [_c('ul', {
	    staticClass: "sidebar-menu"
	  }, [_c('li', {
	    staticClass: "header"
	  }, [_vm._v("MAIN NAVIGATION")]), _vm._v(" "), (_vm.fullAdmin >= 30) ? _c('li', {
	    staticClass: "treeview active"
	  }, [_vm._m(0), _vm._v(" "), _c('ul', {
	    staticClass: "treeview-menu"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/servers-data"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-circle-o"
	  }), _vm._v(" "), _c('span', [_vm._v("Informations")])])], 1), _vm._v(" "), (_vm.fullAdmin >= 40) ? _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/sql"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-circle-o"
	  }), _vm._v(" "), _c('span', [_vm._v("Execute SQL")])])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.fullAdmin >= 30) ? _c('li', {
	    staticClass: "treeview active"
	  }, [_vm._m(1), _vm._v(" "), _c('ul', {
	    staticClass: "treeview-menu"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/users"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-circle-o"
	  }), _vm._v(" "), _c('span', [_vm._v("Users")])])], 1), _vm._v(" "), (_vm.fullAdmin >= 40) ? _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/all-info"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-circle-o"
	  }), _vm._v(" "), _c('span', [_vm._v("Search User")])])], 1) : _vm._e(), _vm._v(" "), (_vm.fullAdmin >= 33) ? _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/ban"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-circle-o"
	  }), _vm._v(" "), _c('span', [_vm._v("Ban")])])], 1) : _vm._e(), _vm._v(" "), (_vm.fullAdmin >= 30) ? _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/coins"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-circle-o"
	  }), _vm._v(" "), _c('span', [_vm._v("Coins")])])], 1) : _vm._e(), _vm._v(" "), (_vm.fullAdmin >= 30) ? _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/facebook-switch"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-circle-o"
	  }), _vm._v(" "), _c('span', [_vm._v("Facebook merge")])])], 1) : _vm._e(), _vm._v(" "), (_vm.fullAdmin >= 33) ? _c('li', [_vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.fullAdmin >= 40) ? _c('li', [_vm._m(3)]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('li', {
	    staticClass: "treeview active"
	  }, [_vm._m(4), _vm._v(" "), _c('ul', {
	    staticClass: "treeview-menu"
	  }, [(_vm.fullAdmin >= 20) ? _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/chats/history"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-circle-o"
	  }), _vm._v(" "), _c('span', [_vm._v("Chat History")])])], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/admin-chat"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-circle-o"
	  }), _vm._v(" "), _c('span', [_vm._v("Admin Chat")])])], 1), _vm._v(" "), _c('li', [(_vm.fullAdmin >= 20) ? _c('router-link', {
	    attrs: {
	      "to": "/chats"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-circle-o"
	  }), _vm._v(" "), _c('span', [_vm._v("Chats")])]) : _vm._e()], 1)])]), _vm._v(" "), _c('li', {
	    staticClass: "treeview active"
	  }, [_vm._m(5), _vm._v(" "), _c('ul', {
	    staticClass: "treeview-menu"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/skins"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-circle"
	  }), _vm._v(" "), _c('span', [_vm._v("Skins")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/private-skins"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-circle"
	  }), _vm._v(" "), _c('span', [_vm._v("Private skins")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/skins-managment"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-circle-o"
	  }), _vm._v(" "), _c('span', [_vm._v("New skins "), _c('span', {
	    staticClass: "label label-info"
	  }, [_vm._v(_vm._s(_vm.$store.state.waitSkins))])])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/private-skins-managment"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-circle-o"
	  }), _vm._v(" "), _c('span', [_vm._v("New private skins "), _c('span', {
	    staticClass: "label label-info"
	  }, [_vm._v(_vm._s(_vm.$store.state.waitPrivateSkins))])])])], 1)])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-cogs"
	  }), _vm._v(" "), _c('span', [_vm._v("Servers")]), _vm._v(" "), _c('span', {
	    staticClass: "pull-right-container"
	  }, [_c('i', {
	    staticClass: "fa fa-angle-left pull-right"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-user"
	  }), _vm._v(" "), _c('span', [_vm._v("User managment")]), _vm._v(" "), _c('span', {
	    staticClass: "pull-right-container"
	  }, [_c('i', {
	    staticClass: "fa fa-angle-left pull-right"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "/analytic"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-google"
	  }), _vm._v(" "), _c('span', [_vm._v("Analytic")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "/block-analytics"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-google"
	  }), _vm._v(" "), _c('span', [_vm._v("Block Analytic")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-comments"
	  }), _vm._v(" "), _c('span', [_vm._v("Chats")]), _vm._v(" "), _c('span', {
	    staticClass: "pull-right-container"
	  }, [_c('i', {
	    staticClass: "fa fa-angle-left pull-right"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-picture-o"
	  }), _vm._v(" "), _c('span', [_vm._v("Skins")]), _vm._v(" "), _c('span', {
	    staticClass: "pull-right-container"
	  }, [_c('i', {
	    staticClass: "fa fa-angle-left pull-right"
	  })])])
	}]}

/***/ }),
/* 307 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_vm._m(0), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('button', {
	    staticClass: "btn btn-default",
	    on: {
	      "click": function($event) {
	        _vm.group = 0
	      }
	    }
	  }, [_vm._v("All")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-primary",
	    on: {
	      "click": function($event) {
	        _vm.group = 1
	      }
	    }
	  }, [_vm._v("Facebook")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-info",
	    on: {
	      "click": function($event) {
	        _vm.group = 2
	      }
	    }
	  }, [_vm._v("E-mail")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('form', {
	    staticClass: "form-horizontal"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "col-sm-2 control-label",
	    attrs: {
	      "for": "type"
	    }
	  }, [_vm._v("Pretraga po:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-10"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.type),
	      expression: "type"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "type"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "nickname",
	      "selected": ""
	    }
	  }, [_vm._v("Nickname")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "email"
	    }
	  }, [_vm._v("Email")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "id"
	    }
	  }, [_vm._v("ID")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "firstname"
	    }
	  }, [_vm._v("First Name")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "lastname"
	    }
	  }, [_vm._v("Last Name")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "color"
	    }
	  }, [_vm._v("Color")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "col-sm-2 control-label",
	    attrs: {
	      "for": "term"
	    }
	  }, [_vm._v("Traži")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-10"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.term),
	      expression: "term"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "autocomplete": "off",
	      "type": "text",
	      "id": "term",
	      "placeholder": "Traži"
	    },
	    domProps: {
	      "value": (_vm.term)
	    },
	    on: {
	      "keyup": function($event) {
	        _vm.searchUser()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.term = $event.target.value
	      }
	    }
	  })])])])])]), _vm._v(" "), _c('table', {
	    staticClass: "table table-hover"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("Nick")]), _vm._v(" "), _c('th', [_vm._v("Name | E-mail")]), _vm._v(" "), _c('th', [_vm._v("Age range")]), _vm._v(" "), (_vm.role >= 40) ? _c('th', [_vm._v("Pwd")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.users), function(user) {
	    return _c('tr', [_c('th', {
	      attrs: {
	        "scope": "row"
	      }
	    }, [_vm._v(_vm._s(user.id))]), _vm._v(" "), _c('td', [_c('form', {
	      staticClass: "form-inline",
	      on: {
	        "submit": function($event) {
	          $event.preventDefault();
	          _vm.changeNick($event)
	        }
	      }
	    }, [_c('input', {
	      staticClass: "user-id",
	      attrs: {
	        "type": "hidden",
	        "name": "user_id"
	      },
	      domProps: {
	        "value": user.id
	      }
	    }), _vm._v(" "), _c('input', {
	      staticClass: "form-control user-nickname",
	      attrs: {
	        "type": "text"
	      },
	      domProps: {
	        "value": _vm.testUri(user.nickname)
	      }
	    }), _vm._v(" "), _c('button', {
	      staticClass: "btn btn-primary",
	      attrs: {
	        "type": "submit"
	      }
	    }, [_vm._v("Sačuvaj")])])]), _vm._v(" "), (user.facebook_id != null) ? _c('td', [_c('a', {
	      attrs: {
	        "href": 'https://facebook.com/' + user.facebook_id
	      }
	    }, [_vm._v("fb: " + _vm._s(user.firstname) + " " + _vm._s(user.lastname))])]) : _c('td', [_vm._v("\n          " + _vm._s(user.email) + "\n        ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.age_range))]), _vm._v(" "), (_vm.role >= 40) ? _c('td', [_vm._v(_vm._s(user.password_view))]) : _vm._e(), _vm._v(" "), _c('td', [_c('button', {
	      staticClass: "btn btn-info",
	      on: {
	        "click": function($event) {
	          _vm.aboutUser(user)
	        }
	      }
	    }, [_vm._v("Info")]), _vm._v(" "), _c('button', {
	      staticClass: "btn btn-danger",
	      on: {
	        "click": function($event) {
	          _vm.deleteUser(user.id)
	        }
	      }
	    }, [_vm._v("Delete")])])])
	  }))]), _vm._v(" "), _c('div', {
	    staticClass: "pagination-wrap"
	  }, [_c('ul', {
	    staticClass: "pagination"
	  }, _vm._l((_vm.numberOfPages), function(cnt) {
	    return _c('li', [_c('a', {
	      class: [cnt == _vm.currentPage ? 'active' : ''],
	      attrs: {
	        "href": "#"
	      },
	      on: {
	        "click": function($event) {
	          _vm.changePage(cnt)
	        }
	      }
	    }, [_vm._v(_vm._s(cnt))])])
	  }))]), _vm._v(" "), _c('div', {
	    staticClass: "modal fade",
	    attrs: {
	      "id": "myModal",
	      "role": "dialog"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog"
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_c('form', {
	    staticClass: "form-horizontal"
	  }, [(_vm.userInfo.id != 0) ? _c('div', [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-sm-3",
	    attrs: {
	      "for": "user_id"
	    }
	  }, [_vm._v("ID:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-9"
	  }, [_c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "user_id",
	      "disabled": ""
	    },
	    domProps: {
	      "value": _vm.userInfo.id
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-sm-3",
	    attrs: {
	      "for": "nickname"
	    }
	  }, [_vm._v("Nickname:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-9"
	  }, [_c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "nickname"
	    },
	    domProps: {
	      "value": _vm.testUri(_vm.userInfo.nickname)
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-sm-3",
	    attrs: {
	      "for": "email"
	    }
	  }, [_vm._v("Email:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-9"
	  }, [_c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "email",
	      "placeholder": "Enter email"
	    },
	    domProps: {
	      "value": _vm.userInfo.email
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-sm-3",
	    attrs: {
	      "for": "password_view"
	    }
	  }, [_vm._v("Password:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-9"
	  }, [_c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "password_view"
	    },
	    domProps: {
	      "value": _vm.userInfo.password_view
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-sm-3",
	    attrs: {
	      "for": "coins"
	    }
	  }, [_vm._v("Coins:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-9"
	  }, [_c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "number",
	      "id": "coins"
	    },
	    domProps: {
	      "value": _vm.userInfo.coins
	    }
	  })])]), _vm._v(" "), (_vm.userInfo.facebook_id != null) ? _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-sm-3",
	    attrs: {
	      "for": "nickname"
	    }
	  }, [_vm._v("Facebook:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-9"
	  }, [_c('div', [_c('a', {
	    attrs: {
	      "href": 'https://facebook.com/' + _vm.userInfo.facebook_id
	    }
	  }, [_vm._v(_vm._s(_vm.userInfo.firstname) + " " + _vm._s(_vm.userInfo.lastname))])]), _vm._v(" "), _c('div', [_c('p', [_vm._v("Age Range: " + _vm._s(_vm.userInfo.age_range))])])])]) : _vm._e(), _vm._v(" "), _vm._m(2), _vm._v(" "), (_vm.userInfo.skins.length) ? _c('div', {
	    staticClass: "ui six stackable cards",
	    attrs: {
	      "id": "skins-cards"
	    }
	  }, _vm._l((_vm.userInfo.skins), function(item) {
	    return _c('div', {
	      staticClass: "col-sm-6 col-md-4 col-lg-3 card",
	      attrs: {
	        "data-skin-id": item.id
	      }
	    }, [_c('img', {
	      staticClass: "card-img-top",
	      attrs: {
	        "src": 'https://agar.rs/public/images/skins/' + item.skin_name + '.png'
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "card-block"
	    }, [_c('div', {
	      staticClass: "card-text"
	    }, [_vm._v("\n                        " + _vm._s(item.ip) + "\n                      ")])]), _vm._v(" "), _c('div', {
	      staticClass: "card-footer"
	    }, [_c('button', {
	      staticClass: "btn btn-danger float-right btn-sm",
	      on: {
	        "click": function($event) {
	          _vm.removePrivateSkinDB(item.id, item.skin_name)
	        }
	      }
	    }, [_vm._v("Delete")])])])
	  })) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "clearfix"
	  })]) : _vm._e()])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("\n      Users\n      "), _c('small', [_vm._v("List of users")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-header"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    }
	  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
	    staticClass: "modal-title"
	  }, [_vm._v("Informacije o igraču:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-sm-3",
	    attrs: {
	      "for": "skins-cards"
	    }
	  }, [_vm._v("Private skins:")])])
	}]}

/***/ }),
/* 308 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_vm._m(0), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('form', {
	    staticClass: "col-sm-6"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.skinSearch),
	      expression: "skinSearch"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "Search..."
	    },
	    domProps: {
	      "value": (_vm.skinSearch)
	    },
	    on: {
	      "keyup": function($event) {
	        _vm.skinSearchDB();
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.skinSearch = $event.target.value
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [(_vm.skins.images.length) ? _c('div', {
	    staticClass: "ui six stackable cards",
	    attrs: {
	      "id": "skins-cards"
	    }
	  }, _vm._l((_vm.skins.visible_images), function(item) {
	    return _c('div', {
	      class: 'col-sm-6 col-md-4 card col-lg-' + _vm.bigScreenSkins,
	      attrs: {
	        "data-skin-id": item.id
	      }
	    }, [_c('img', {
	      staticClass: "card-img-top",
	      attrs: {
	        "src": _vm.baseUrl2 + '/public/images/skins_pre/' + item.skin_name + '.png'
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "card-block"
	    }, [_c('div', {
	      staticClass: "card-text"
	    }, [(_vm.role >= 33) ? _c('span', [_vm._v(_vm._s(item.ip))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	      staticClass: "card-footer"
	    }, [_c('h4', {
	      staticClass: "text-center card-title mt-3"
	    }, [_vm._v(_vm._s(item.skin_name))]), _vm._v(" "), _c('div', {
	      staticClass: "card-text"
	    }, [_vm._v("\n                " + _vm._s(item.additional_info) + "\n              ")]), _vm._v(" "), _c('button', {
	      staticClass: "btn btn-danger btn-sm",
	      on: {
	        "click": function($event) {
	          _vm.removeSkinDB(item.id, item.skin_name)
	        }
	      }
	    }, [_vm._v("Delete")]), _vm._v(" "), _c('button', {
	      staticClass: "btn btn-success pull-right btn-sm",
	      on: {
	        "click": function($event) {
	          _vm.approveSkin(item.skin_name)
	        }
	      }
	    }, [_vm._v("Approve")])])])
	  })) : _vm._e()])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("\n      Skins\n      "), _c('small', [_vm._v("accept or decline skins")])])])
	}]}

/***/ }),
/* 309 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("\n            Administration\n        ")]), _vm._v(" "), _c('ul', {
	    staticClass: "sidebar-menu"
	  }, [_c('li', {
	    staticClass: "header"
	  }, [_vm._v("MAIN NAVIGATION")]), _vm._v(" "), (_vm.fullAdmin >= 30) ? _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/servers-data"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-gear"
	  }), _vm._v(" "), _c('span', [_vm._v("Informations")])])], 1) : _vm._e(), _vm._v(" "), (_vm.fullAdmin >= 40) ? _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/sql"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-gear"
	  }), _vm._v(" "), _c('span', [_vm._v("SQL Execute")])])], 1) : _vm._e(), _vm._v(" "), (_vm.fullAdmin >= 20) ? _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/chats/history"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-comments"
	  }), _vm._v(" "), _c('span', [_vm._v("Chat History")])])], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/admin-chat"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-comments"
	  }), _vm._v(" "), _c('span', [_vm._v("Admin Chat")])])], 1), _vm._v(" "), _c('li', [(_vm.fullAdmin >= 20) ? _c('router-link', {
	    attrs: {
	      "to": "/chats"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-comments"
	  }), _vm._v(" "), _c('span', [_vm._v("Chats")])]) : _vm._e()], 1), _vm._v(" "), (_vm.fullAdmin >= 33) ? _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/users"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-user"
	  }), _vm._v(" "), _c('span', [_vm._v("Users")])])], 1) : _vm._e(), _vm._v(" "), (_vm.fullAdmin >= 33) ? _c('li', [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.fullAdmin >= 40) ? _c('li', [_vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.fullAdmin >= 33) ? _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/ban"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-ban"
	  }), _vm._v(" "), _c('span', [_vm._v("Ban")])])], 1) : _vm._e(), _vm._v(" "), (_vm.fullAdmin >= 30) ? _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/facebook-switch"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-user"
	  }), _vm._v(" "), _c('span', [_vm._v("Facebook merge")])])], 1) : _vm._e(), _vm._v(" "), (_vm.fullAdmin >= 30) ? _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/coins"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-money"
	  }), _vm._v(" "), _c('span', [_vm._v("Coins")])])], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/skins"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-picture-o"
	  }), _vm._v(" "), _c('span', [_vm._v("Skins")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/private-skins"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-picture-o"
	  }), _vm._v(" "), _c('span', [_vm._v("Private skins")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/skins-managment"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-picture-o"
	  }), _vm._v(" "), _c('span', [_vm._v("New skins "), _c('span', {
	    staticClass: "label label-info"
	  }, [_vm._v(_vm._s(_vm.waitSkins))])])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/private-skins-managment"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-picture-o"
	  }), _vm._v(" "), _c('span', [_vm._v("New private skins "), _c('span', {
	    staticClass: "label label-info"
	  }, [_vm._v(_vm._s(_vm.waitPrivateSkins))])])])], 1)])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-lg-3 col-xs-6"
	  }, [_c('div', {
	    staticClass: "small-box bg-aqua"
	  }, [_c('div', {
	    staticClass: "inner"
	  }, [_c('h3', [_vm._v(_vm._s(_vm.number_of_skins))]), _vm._v(" "), _c('p', [_vm._v("Skinova")])]), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div', {
	    staticClass: "col-lg-3 col-xs-6"
	  }, [_c('div', {
	    staticClass: "small-box bg-red"
	  }, [_c('div', {
	    staticClass: "inner"
	  }, [_c('h3', [_vm._v(_vm._s(_vm.number_of_private_skins))]), _vm._v(" "), _c('p', [_vm._v("Privatnih skinova")])]), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('div', {
	    staticClass: "col-lg-3 col-xs-6"
	  }, [_c('div', {
	    staticClass: "small-box bg-red"
	  }, [_c('div', {
	    staticClass: "inner"
	  }, [_c('h3', [_vm._v(_vm._s(_vm.number_of_users))]), _vm._v(" "), _c('p', [_vm._v("Registrovanih igrača")])]), _vm._v(" "), _vm._m(4)])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "/analytic"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-google"
	  }), _vm._v(" "), _c('span', [_vm._v("Analytic")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "/block-analytics"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-google"
	  }), _vm._v(" "), _c('span', [_vm._v("Block Analytics")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "icon"
	  }, [_c('i', {
	    staticClass: "fa fa-photo"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "icon"
	  }, [_c('i', {
	    staticClass: "fa fa-photo"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "icon"
	  }, [_c('i', {
	    staticClass: "ion ion-pie-graph"
	  })])
	}]}

/***/ }),
/* 310 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "wrapper",
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('router-view')], 1)
	},staticRenderFns: []}

/***/ }),
/* 311 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_vm._m(0), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('form', {
	    staticClass: "col-sm-6"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.skinSearch),
	      expression: "skinSearch"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "Search..."
	    },
	    domProps: {
	      "value": (_vm.skinSearch)
	    },
	    on: {
	      "keyup": function($event) {
	        _vm.skinSearchDB();
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.skinSearch = $event.target.value
	      }
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [(_vm.skins.images.length) ? _c('div', {
	    staticClass: "ui six stackable cards",
	    attrs: {
	      "id": "skins-cards"
	    }
	  }, _vm._l((_vm.skins.visible_images), function(item) {
	    return _c('div', {
	      class: 'col-sm-6 col-md-4 card col-lg-' + _vm.bigScreenSkins,
	      attrs: {
	        "data-skin-id": item.id
	      }
	    }, [_c('img', {
	      staticClass: "card-img-top",
	      attrs: {
	        "src": _vm.baseUrl2 + '/public/images/skins_pending/' + item.skin_name + '.png'
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "card-block"
	    }, [_c('div', {
	      staticClass: "card-text"
	    }, [(_vm.role >= 33) ? _c('span', [_vm._v(_vm._s(item.ip))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	      staticClass: "card-footer"
	    }, [_c('h4', {
	      staticClass: "text-center card-title mt-3"
	    }, [_vm._v(_vm._s(item.skin_name))]), _vm._v(" "), _c('div', {
	      staticClass: "card-text"
	    }, [_vm._v("\n                " + _vm._s(item.additional_info) + "\n              ")]), _vm._v(" "), _c('button', {
	      staticClass: "btn btn-danger btn-sm",
	      on: {
	        "click": function($event) {
	          _vm.removeSkinDB(item.id, item.skin_name)
	        }
	      }
	    }, [_vm._v("Delete")]), _vm._v(" "), _c('button', {
	      staticClass: "btn btn-success pull-right btn-sm",
	      on: {
	        "click": function($event) {
	          _vm.approveSkin(item.skin_name)
	        }
	      }
	    }, [_vm._v("Approve")])])])
	  })) : _vm._e()])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("\n      Skins\n      "), _c('small', [_vm._v("accept or decline skins")])])])
	}]}

/***/ }),
/* 312 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_vm._m(0), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "  "
	  }, [_c('div', {
	    staticClass: "form-inline"
	  }, [_c('div', {
	    staticClass: "form-group query-input"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.state),
	      expression: "state"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "Type your query...",
	      "id": "query"
	    },
	    domProps: {
	      "value": (_vm.state)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.state = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-primary pull-right",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.executeSQL()
	      }
	    }
	  }, [_vm._v("Execute")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.status == -1 && _vm.msg != ''),
	      expression: "status == -1 && msg != ''"
	    }],
	    staticClass: "alert-error"
	  }, [_vm._v("\n            " + _vm._s(_vm.msg) + "\n        ")]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.status == 1 && _vm.msg != ''),
	      expression: "status == 1 && msg != ''"
	    }],
	    staticClass: "alert-success"
	  }, [_vm._v("\n            " + _vm._s(_vm.msg) + "\n        ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "results"
	  }, [_c('div', {
	    staticClass: "table-responsive"
	  }, [(_vm.resultLength > 0) ? _c('table', {
	    staticClass: "table table-striped"
	  }, [_c('thead', [_c('tr', _vm._l((_vm.result[0]), function(value, propertyName) {
	    return _c('th', [_vm._v(_vm._s(propertyName))])
	  }))]), _vm._v(" "), _c('tbody', _vm._l((_vm.result), function(row) {
	    return _c('tr', _vm._l((row), function(value, propertyName) {
	      return _c('td', [_vm._v(_vm._s(_vm.decoded(value)))])
	    }))
	  }))]) : _vm._e()])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("\n      SQL execute\n      "), _c('small', [_vm._v("Type and execute SQL")])])])
	}]}

/***/ }),
/* 313 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_vm._m(0), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [(_vm.skins.images.length) ? _c('div', {
	    staticClass: "ui six stackable cards",
	    attrs: {
	      "id": "skins-cards"
	    }
	  }, _vm._l((_vm.skins.visible_images), function(item) {
	    return _c('div', {
	      class: 'col-sm-6 col-md-4 card col-lg-' + _vm.bigScreenSkins,
	      attrs: {
	        "data-skin-id": item.id
	      }
	    }, [_c('img', {
	      staticClass: "card-img-top",
	      attrs: {
	        "src": _vm.baseUrl2 + '/public/images/skins_pre/' + item.skin_name + '.png'
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "card-block"
	    }, [_c('div', {
	      staticClass: "card-text"
	    }, [(_vm.role >= 33) ? _c('span', [_vm._v(_vm._s(item.ip))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	      staticClass: "card-footer"
	    }, [_c('h4', {
	      staticClass: "text-center card-title mt-3"
	    }, [_vm._v(_vm._s(decodeURI(item.nickname)) + "\n                "), _c('a', {
	      staticStyle: {
	        "font-size": "14px"
	      },
	      attrs: {
	        "href": 'https://fb.com/' + item.facebook_id
	      }
	    }, [_vm._v(" | " + _vm._s(item.firstname) + " " + _vm._s(item.lastname))])]), _vm._v(" "), _c('div', {
	      staticClass: "card-text"
	    }, [_vm._v("\n                " + _vm._s(item.additional_info) + "\n              ")]), _vm._v(" "), _c('button', {
	      staticClass: "btn btn-danger btn-sm",
	      on: {
	        "click": function($event) {
	          _vm.removeSkinDB(item.skin_name, item.id)
	        }
	      }
	    }, [_vm._v("Delete")]), _vm._v(" "), _c('button', {
	      staticClass: "btn btn-success pull-right btn-sm",
	      on: {
	        "click": function($event) {
	          _vm.approveSkin(item.skin_name, item.id)
	        }
	      }
	    }, [_vm._v("Approve")])])])
	  })) : _vm._e()])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("\n      Private Skins\n      "), _c('small', [_vm._v("accept or decline skins")])])])
	}]}

/***/ }),
/* 314 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('footer', {
	    staticClass: "main-footer"
	  }, [_c('strong', [_vm._v("Copyright © 2020 "), _c('a', {
	    attrs: {
	      "href": "https://agar.rs"
	    }
	  }, [_vm._v("Agar Balkan")]), _vm._v(".")]), _vm._v(" All\n  rights\n  reserved.\n")])
	}]}

/***/ }),
/* 315 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_vm._m(0), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    staticClass: "box box-info"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', [_c('form', {
	    staticClass: "form-horizontal"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "col-sm-2 control-label",
	    attrs: {
	      "for": "type"
	    }
	  }, [_vm._v("Pretraga po:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-10"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.type),
	      expression: "type"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "type"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "nickname",
	      "selected": ""
	    }
	  }, [_vm._v("Nickname")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "email"
	    }
	  }, [_vm._v("Email")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "id"
	    }
	  }, [_vm._v("ID")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "firstname"
	    }
	  }, [_vm._v("Ime")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "lastname"
	    }
	  }, [_vm._v("Prezime")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "col-sm-2 control-label",
	    attrs: {
	      "for": "term"
	    }
	  }, [_vm._v("Traži")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-10"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.term),
	      expression: "term"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "autocomplete": "off",
	      "type": "text",
	      "id": "term",
	      "placeholder": "Traži"
	    },
	    domProps: {
	      "value": (_vm.term)
	    },
	    on: {
	      "keyup": function($event) {
	        _vm.searchUser()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.term = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "search-results-list"
	  }, [_c('ul', {
	    staticClass: "list-group"
	  }, _vm._l((_vm.userList), function(user) {
	    return _c('li', {
	      staticClass: "list-group-item",
	      staticStyle: {
	        "cursor": "pointer"
	      },
	      on: {
	        "click": function($event) {
	          _vm.pickUser(user)
	        }
	      }
	    }, [_vm._v(_vm._s(decodeURI(user.nickname)))])
	  })), _vm._v(" "), (_vm.userList.length > 0 && _vm.selected_user == 0) ? _c('small', [_vm._v("Klikni na rezultat da odabereš igrača.")]) : _vm._e(), _vm._v(" "), (_vm.userList.length == 0 && _vm.term.length > 0) ? _c('p', [_vm._v("Nije pronađen igrač.")]) : _vm._e()])])]), _vm._v(" "), (_vm.selected_user > 0) ? _c('div', [_c('div', {
	    staticClass: "jumbotron"
	  }, [_c('p', [_vm._v("Nick: " + _vm._s(decodeURI(_vm.userInfo.nickname)))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.userInfo.email) + " " + _vm._s(_vm.userInfo.firstname) + " " + _vm._s(_vm.userInfo.lastname))]), _vm._v(" "), _c('p', [_vm._v("Coins: " + _vm._s(_vm.userInfo.coins))]), _vm._v(" "), _c('p', [_vm._v("ID: " + _vm._s(_vm.userInfo.id))]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "col-sm-2 control-label",
	    attrs: {
	      "for": "reason"
	    }
	  }, [_vm._v("Razlog")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-10"
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.reason),
	      expression: "reason"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "reason",
	      "rows": "2"
	    },
	    domProps: {
	      "value": (_vm.reason)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.reason = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "col-sm-4 control-label",
	    attrs: {
	      "for": "reason"
	    }
	  }, [_vm._v("Broj zlatnika")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-8"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.coins_number),
	      expression: "coins_number"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "number",
	      "id": "coins_number"
	    },
	    domProps: {
	      "value": (_vm.coins_number)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.coins_number = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "box-footer"
	  }, [_c('div', [_c('p', {
	    staticClass: "text-danger text-right"
	  }, [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-info pull-right",
	    attrs: {
	      "disabled": _vm.coins_number == 0,
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.addCoins()
	      }
	    }
	  }, [_vm._v("\n                        Add Coins\n                      ")])])])]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('table', {
	    staticClass: "table table-condensed table-striped"
	  }, [_vm._m(2), _vm._v(" "), (_vm.transactions.length > 0) ? _c('tbody', _vm._l((_vm.transactions), function(transaction) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(decodeURI(transaction.nickname)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(transaction.reason))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(transaction.coins_number))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(transaction.from_admin))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(transaction.date))])])
	  })) : _c('tbody', [_c('div', {
	    staticClass: "ui hidden divider"
	  }), _vm._v(" "), _c('h3', [_vm._v("\n            List is empty\n          ")]), _vm._v(" "), _c('div', {
	    staticClass: "ui hidden divider"
	  })])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("\n      Highscores\n      "), _c('small', [_vm._v("All time")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Coin form")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', [_vm._v("Nick")]), _vm._v(" "), _c('th', [_vm._v("Reason")]), _vm._v(" "), _c('th', [_vm._v("Coins")]), _vm._v(" "), _c('th', [_vm._v("From")]), _vm._v(" "), _c('th', [_vm._v("Date")])])])
	}]}

/***/ }),
/* 316 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "login-box"
	  }, [_c('div', {
	    staticClass: "login-logo"
	  }, [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('b', [_vm._v("Admin")]), _vm._v(" Agar Balkan")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "login-box-body"
	  }, [_c('p', {
	    staticClass: "login-box-msg"
	  }, [_vm._v("Sign in to start your session")]), _vm._v(" "), _c('form', {
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.Login($event)
	      }
	    }
	  }, [(_vm.error) ? _c('div', {
	    staticClass: "alert alert-danger"
	  }, [_c('a', {
	    staticClass: "close",
	    attrs: {
	      "data-dismiss": "alert"
	    }
	  }, [_vm._v("×")]), _vm._v("\n        " + _vm._s(_vm.error) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "form-group has-feedback"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.credentials.email),
	      expression: "credentials.email"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "Username"
	    },
	    domProps: {
	      "value": (_vm.credentials.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.credentials.email = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon glyphicon-user form-control-feedback"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "form-group has-feedback"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.credentials.password),
	      expression: "credentials.password"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "password",
	      "placeholder": "Password"
	    },
	    domProps: {
	      "value": (_vm.credentials.password)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.credentials.password = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon glyphicon-lock form-control-feedback"
	  })]), _vm._v(" "), _vm._m(0)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-8"
	  }, [_c('div', {
	    staticClass: "checkbox icheck"
	  }, [_c('label', [_c('div', {
	    staticClass: "icheckbox_square-blue",
	    staticStyle: {
	      "position": "relative"
	    },
	    attrs: {
	      "aria-checked": "false",
	      "aria-disabled": "false"
	    }
	  }, [_c('input', {
	    staticStyle: {
	      "position": "absolute",
	      "top": "-20%",
	      "left": "-20%",
	      "display": "block",
	      "width": "140%",
	      "height": "140%",
	      "margin": "0px",
	      "padding": "0px",
	      "border": "0px",
	      "opacity": "0",
	      "background": "rgb(255, 255, 255)"
	    },
	    attrs: {
	      "type": "checkbox"
	    }
	  }), _c('ins', {
	    staticClass: "iCheck-helper",
	    staticStyle: {
	      "position": "absolute",
	      "top": "-20%",
	      "left": "-20%",
	      "display": "block",
	      "width": "140%",
	      "height": "140%",
	      "margin": "0px",
	      "padding": "0px",
	      "border": "0px",
	      "opacity": "0",
	      "background": "rgb(255, 255, 255)"
	    }
	  })]), _vm._v(" Remember Me\n          ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-4"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-block btn-flat",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v("Sign In")])])])
	}]}

/***/ }),
/* 317 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("\n      Blocked Analyics\n      "), _c('small')])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "input-group date",
	    attrs: {
	      "id": "datetimepicker1"
	    }
	  }, [_c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "input-group-addon"
	  }, [_c('span', {
	    staticClass: "glyphicon glyphicon-calendar"
	  })])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('iframe', {
	    attrs: {
	      "id": "analytics"
	    }
	  })])])])
	}]}

/***/ }),
/* 318 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_vm._m(0), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-footer"
	  }, _vm._l((_vm.servers), function(server) {
	    return _c('iframe', {
	      attrs: {
	        "src": '/static/chats/chat-main.html?ip=' + server.ip + ':' + server.gamePort + '&nickname=' + _vm.safeName + '&server=' + encodeURIComponent(server.name)
	      }
	    })
	  }))])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("\n      Chats\n      "), _c('small', [_vm._v("All chats in one page")])])])
	}]}

/***/ }),
/* 319 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_vm._m(0), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    staticClass: "box box-info"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('div', [_c('form', {
	    staticClass: "form-horizontal"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "col-sm-2 control-label",
	    attrs: {
	      "for": "nickname"
	    }
	  }, [_vm._v("Nick")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-10"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.nickname),
	      expression: "nickname"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "nickname",
	      "placeholder": "Nickname"
	    },
	    domProps: {
	      "value": (_vm.nickname)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.nickname = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "col-sm-2 control-label",
	    attrs: {
	      "for": "ip-address"
	    }
	  }, [_vm._v("IP")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-10"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.trim",
	      value: (_vm.ip),
	      expression: "ip",
	      modifiers: {
	        "trim": true
	      }
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "ip-address",
	      "placeholder": "IP address"
	    },
	    domProps: {
	      "value": (_vm.ip)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.ip = $event.target.value.trim()
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  })])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "col-sm-2 control-label",
	    attrs: {
	      "for": "type"
	    }
	  }, [_vm._v("Ban type")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-10"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.type),
	      expression: "type"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "type"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_vm._v("Game - preusmerava na stranu ban")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "2"
	    }
	  }, [_vm._v("Chat - gasi mu chat")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "3"
	    }
	  }, [_vm._v("Skins - zabrana dodavanja")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "4"
	    }
	  }, [_vm._v("Igra - ubija tab (oprezno)")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5"
	    }
	  }, [_vm._v("Salje mu poruku iz 'Reasona'")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "6"
	    }
	  }, [_vm._v("Protrese mu ekran svakih 20 sek. Unban da ne trese stalno.")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "col-sm-2 control-label",
	    attrs: {
	      "for": "reason"
	    }
	  }, [_vm._v("Reason")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-10"
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.reason),
	      expression: "reason"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "reason",
	      "rows": "2"
	    },
	    domProps: {
	      "value": (_vm.reason)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.reason = $event.target.value
	      }
	    }
	  })])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-footer"
	  }, [_c('div', [_c('p', {
	    staticClass: "text-danger text-right"
	  }, [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-info pull-right",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.ban()
	      }
	    }
	  }, [_vm._v("\n                Ban\n              ")])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('table', {
	    staticClass: "table table-condensed table-striped"
	  }, [_vm._m(3), _vm._v(" "), (_vm.bannedList.length > 0) ? _c('tbody', _vm._l((_vm.bannedList), function(ban) {
	    return _c('tr', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (_vm.current_date < ban.date_to),
	        expression: "current_date < ban.date_to"
	      }]
	    }, [_c('td', [_vm._v(_vm._s(decodeURI(ban.nickname)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.calcType(ban.type)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ban.reason))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ban.date_from))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ban.date_to))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ban.ip))]), _vm._v(" "), _c('td', [_c('button', {
	      staticClass: "btn btn-danger",
	      on: {
	        "click": function($event) {
	          _vm.unban(ban.id)
	        }
	      }
	    }, [_vm._v("Unban")])])])
	  })) : _c('tbody', [_c('div', {
	    staticClass: "ui hidden divider"
	  }), _vm._v(" "), _c('h3', [_vm._v("\n            List is empty\n          ")]), _vm._v(" "), _c('div', {
	    staticClass: "ui hidden divider"
	  })])]), _vm._v(" "), _vm._m(4)])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("\n      Ban by IP\n      "), _c('small', [_vm._v("Here you can ban users")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-header with-border"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("Ban user")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "col-sm-2 control-label",
	    attrs: {
	      "for": "datetimepicker"
	    }
	  }, [_vm._v("Date to")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-10"
	  }, [_c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "datetimepicker"
	    }
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', [_vm._v("Nick")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Reason")]), _vm._v(" "), _c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Expire")]), _vm._v(" "), _c('th', [_vm._v("IP")]), _vm._v(" "), _c('th', [_vm._v("Action")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('p', [_vm._v("Ukoliko unbanujes nekog, posalji mu link: "), _c('a', {
	    attrs: {
	      "href": "https://agar.rs/unba.html"
	    }
	  }, [_vm._v("http://agar.rs/unba.html")])])])
	}]}

/***/ }),
/* 320 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_vm._m(0), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "error-page"
	  }, [_c('h2', {
	    staticClass: "headline text-yellow"
	  }, [_vm._v(" 404")]), _vm._v(" "), _c('div', {
	    staticClass: "error-content"
	  }, [_vm._m(1), _vm._v(" "), _c('p', [_vm._v("\n                    We could not find the page you were looking for.\n                    Meanwhile, you may "), _c('router-link', {
	    attrs: {
	      "to": "/dashboard"
	    }
	  }, [_vm._v("return to dashboard")]), _vm._v(" or try using the search form.\n                ")], 1), _vm._v(" "), _vm._m(2)])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("\n            404 Error Page\n        ")]), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-dashboard"
	  }), _vm._v(" Home")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Examples")])]), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("404 error")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h3', [_c('i', {
	    staticClass: "fa fa-warning text-yellow"
	  }), _vm._v(" Oops! Page not found.")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('form', {
	    staticClass: "search-form"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "search",
	      "placeholder": "Search"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "input-group-btn"
	  }, [_c('button', {
	    staticClass: "btn btn-warning btn-flat",
	    attrs: {
	      "type": "submit",
	      "name": "submit"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-search"
	  })])])])])
	}]}

/***/ }),
/* 321 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_vm._m(0), _vm._v(" "), _c('section', {
	    staticClass: "content admin-chat"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-9"
	  }, [_c('transition', {
	    attrs: {
	      "name": "slide-fade"
	    }
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "messages"
	  }, [_c('ul', _vm._l((_vm.messages), function(msg) {
	    return _c('li', [_c('div', {
	      staticClass: "media-content"
	    }, [_c('div', {}, [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.decoded(msg.user)))]), _vm._v(" "), _c('small', [_vm._v(_vm._s(msg.date))]), _vm._v(" "), _c('br'), _vm._v("\n                                                " + _vm._s(msg.text) + "\n                                            ")])])])])
	  }))]), _vm._v(" "), _c('div', {
	    staticClass: "controls field has-addons"
	  }, [_c('div', {
	    staticClass: "control is-expanded"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.message),
	      expression: "message"
	    }],
	    staticClass: "input is-primary",
	    attrs: {
	      "placeholder": "Write message",
	      "autofocus": ""
	    },
	    domProps: {
	      "value": (_vm.message)
	    },
	    on: {
	      "keydown": function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
	        _vm.sendMessage()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.message = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "control"
	  }, [_c('button', {
	    staticClass: "button is-primary",
	    attrs: {
	      "disabled": _vm.message == ''
	    },
	    on: {
	      "click": function($event) {
	        _vm.sendMessage()
	      }
	    }
	  }, [_vm._v("Send")])])])])])], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', [_c('h4', {
	    staticClass: "title is-4"
	  }, [_vm._v("Current users (" + _vm._s(_vm.users.length) + ")")]), _vm._v(" "), _c('ul', _vm._l((_vm.users), function(user) {
	    return _c('li', [_c('div', {
	      staticClass: "media-content"
	    }, [_c('div', {}, [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.decoded(user.name)))])])])])])
	  }))])])]), _vm._v(" "), _c('br')])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("\n      Chat for Admins\n      "), _c('small')])])
	}]}

/***/ }),
/* 322 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('header', {
	    staticClass: "main-header"
	  }, [_c('router-link', {
	    staticClass: "logo",
	    attrs: {
	      "to": "/dashboard"
	    }
	  }, [_c('span', {
	    staticClass: "logo-mini"
	  }, [_c('b', [_vm._v("A")]), _vm._v("B")]), _vm._v(" "), _c('span', {
	    staticClass: "logo-lg"
	  }, [_c('b', [_vm._v("Admin")]), _vm._v(" AB")])]), _vm._v(" "), _c('nav', {
	    staticClass: "navbar navbar-static-top"
	  }, [_c('div', {
	    staticClass: "navbar-custom-menu"
	  }, [_c('ul', {
	    staticClass: "nav navbar-nav"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.logout($event)
	      }
	    }
	  }, [_vm._v("Sign out " + _vm._s(decodeURI(_vm.nickname)))])]), _vm._v(" "), _vm._m(0)])])])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_c('a', {
	    attrs: {
	      "href": "#",
	      "data-toggle": "control-sidebar"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-gears"
	  })])])
	}]}

/***/ }),
/* 323 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_vm._m(0), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [(_vm.skins.images.length) ? _c('div', {
	    staticClass: "ui six stackable cards",
	    attrs: {
	      "id": "skins-cards"
	    }
	  }, _vm._l((_vm.skins.visible_images), function(item) {
	    return _c('div', {
	      class: 'col-sm-6 col-md-4 card col-lg-' + _vm.bigScreenSkins,
	      attrs: {
	        "data-skin-id": item.id
	      }
	    }, [_c('img', {
	      staticClass: "card-img-top",
	      attrs: {
	        "src": _vm.baseUrl2 + '/public/images/skins/' + item.skin_name + '.png'
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "card-block"
	    }, [_c('div', {
	      staticClass: "card-text"
	    }, [(_vm.role >= 33) ? _c('span', [_vm._v(_vm._s(item.ip))]) : _vm._e(), _vm._v(" "), (_vm.role >= 33) ? _c('span', {
	      staticClass: "pull-right"
	    }, [_vm._v(_vm._s(item.approved_by))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	      staticClass: "card-footer"
	    }, [_c('h4', {
	      staticClass: "text-center card-title mt-3"
	    }, [_vm._v(_vm._s(item.user_id))]), _vm._v(" "), _c('h4', {
	      staticClass: "text-center card-title mt-3"
	    }, [_vm._v(_vm._s(decodeURI(item.nickname)))]), _vm._v(" "), _c('button', {
	      staticClass: "btn btn-danger float-right btn-sm",
	      on: {
	        "click": function($event) {
	          _vm.removePrivateSkinDB(item.id, item.skin_name)
	        }
	      }
	    }, [_vm._v("Delete")])])])
	  })) : _vm._e()])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("\n      Private Skins\n      "), _c('small', [_vm._v("Private Skin list")])])])
	}]}

/***/ }),
/* 324 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('app-header'), _vm._v(" "), _c('app-sidebar'), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('app-footer'), _vm._v(" "), _c('control-sidebar')], 1)
	},staticRenderFns: []}

/***/ }),
/* 325 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_vm._m(0), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('ol', _vm._l((_vm.servers), function(server) {
	    return _c('li', [_vm._v("\n\n          " + _vm._s(server.name) + "\n          "), _c('ul', [_c('li', [_vm._v("ID: " + _vm._s(server.shortUrl))]), _vm._v(" "), _c('li', [_vm._v("Short name: " + _vm._s(server.short_name))]), _vm._v(" "), _c('li', [_vm._v("IP: " + _vm._s(server.ip) + ":" + _vm._s(server.gamePort))]), _vm._v(" "), (server.ips) ? _c('li', [_vm._v("IP secure: " + _vm._s(server.ips) + ":" + _vm._s(server.gamePort))]) : _vm._e(), _vm._v(" "), _c('li', [_vm._v("Stats port: " + _vm._s(server.statPort))])])])
	  }))])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("\n      Servers\n      "), _c('small', [_vm._v("Informations about servers")])])])
	}]}

/***/ }),
/* 326 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("\n      Detaljna pretraga\n      "), (_vm.ip.address != '') ? _c('small', [_c('span', [_vm._v("IP: "), _c('strong', [_vm._v(_vm._s(_vm.ip.address))]), _vm._v(", ")]), _vm._v(" "), _c('span', [_vm._v("City: "), _c('strong', [_vm._v(_vm._s(_vm.ip.city))]), _vm._v(", ")]), _vm._v(" "), _c('span', [_vm._v("Country: "), _c('strong', [_vm._v(_vm._s(_vm.ip.country))]), _vm._v(", ")]), _vm._v(" "), _c('span', [_vm._v("ISP: "), _c('strong', [_vm._v(_vm._s(_vm.ip.isp))])])]) : _vm._e()])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('form', {
	    staticClass: "form-horizontal"
	  }, [_c('div', {
	    staticClass: "col-md-2"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.type),
	      expression: "type"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "type"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "nickname",
	      "selected": ""
	    }
	  }, [_vm._v("Nickname")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "ip"
	    }
	  }, [_vm._v("IP")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    staticClass: "margin-input form-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.term),
	      expression: "term"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "term",
	      "placeholder": _vm.type,
	      "focus": ""
	    },
	    domProps: {
	      "value": (_vm.term)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.term = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4"
	  }, [_c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.searchUser()
	      }
	    }
	  }, [_vm._v("Search")]), _vm._v(" "), (_vm.userInfo.id != 0) ? _c('button', {
	    staticClass: "btn btn-info",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.aboutUser()
	      }
	    }
	  }, [_vm._v("ID: " + _vm._s(_vm.userInfo.id))]) : _vm._e()])])])]), _vm._v(" "), (_vm.error.length > 0) ? _c('div', {
	    staticClass: "alert alert-danger",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.error) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-6"
	  }, [_c('ul', {
	    staticClass: "list"
	  }, _vm._l((_vm.data.nicknames), function(dt) {
	    return _c('li', {
	      on: {
	        "click": function($event) {
	          _vm.copyNick(dt)
	        }
	      }
	    }, [_c('span', [_vm._v(_vm._s(_vm.testUri(dt)) + " ")])])
	  }))]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-6"
	  }, [_c('ul', {
	    staticClass: "list"
	  }, _vm._l((_vm.data.allIp), function(ip) {
	    return _c('li', {
	      on: {
	        "click": function($event) {
	          _vm.copyIP(ip)
	        }
	      }
	    }, [_c('span', [_vm._v(_vm._s(ip))])])
	  }))]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-4"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "modal fade",
	    attrs: {
	      "id": "myModal",
	      "role": "dialog"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog"
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_c('form', {
	    staticClass: "form-horizontal"
	  }, [(_vm.userInfo.id != 0) ? _c('div', [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-sm-3",
	    attrs: {
	      "for": "user_id"
	    }
	  }, [_vm._v("ID:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-9"
	  }, [_c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "user_id",
	      "disabled": ""
	    },
	    domProps: {
	      "value": _vm.userInfo.id
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-sm-3",
	    attrs: {
	      "for": "nickname"
	    }
	  }, [_vm._v("Nickname:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-9"
	  }, [_c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "nickname"
	    },
	    domProps: {
	      "value": _vm.testUri(_vm.userInfo.nickname)
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-sm-3",
	    attrs: {
	      "for": "email"
	    }
	  }, [_vm._v("Email:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-9"
	  }, [_c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "email",
	      "placeholder": "Enter email"
	    },
	    domProps: {
	      "value": _vm.userInfo.email
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-sm-3",
	    attrs: {
	      "for": "password_view"
	    }
	  }, [_vm._v("Password:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-9"
	  }, [_c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "password_view"
	    },
	    domProps: {
	      "value": _vm.userInfo.password_view
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-sm-3",
	    attrs: {
	      "for": "coins"
	    }
	  }, [_vm._v("Coins:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-9"
	  }, [_c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "type": "number",
	      "id": "coins"
	    },
	    domProps: {
	      "value": _vm.userInfo.coins
	    }
	  })])]), _vm._v(" "), (_vm.userInfo.facebook_id != null) ? _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-sm-3",
	    attrs: {
	      "for": "nickname"
	    }
	  }, [_vm._v("Facebook:")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-9"
	  }, [_c('div', [_c('a', {
	    attrs: {
	      "href": 'https://facebook.com/' + _vm.userInfo.facebook_id
	    }
	  }, [_vm._v(_vm._s(_vm.userInfo.firstname) + " " + _vm._s(_vm.userInfo.lastname))])]), _vm._v(" "), _c('div', [_c('p', [_vm._v("Age Range: " + _vm._s(_vm.userInfo.age_range))])])])]) : _vm._e(), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.userInfo.skins.length) ? _c('div', {
	    staticClass: "ui six stackable cards",
	    attrs: {
	      "id": "skins-cards"
	    }
	  }, _vm._l((_vm.userInfo.skins), function(item) {
	    return _c('div', {
	      staticClass: "col-sm-6 col-md-4 col-lg-3 card",
	      attrs: {
	        "data-skin-id": item.id
	      }
	    }, [_c('img', {
	      staticClass: "card-img-top",
	      attrs: {
	        "src": 'https://agar.rs/public/images/skins/' + item.skin_name + '.png'
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "card-block"
	    }, [_c('div', {
	      staticClass: "card-text"
	    }, [_vm._v("\n                        " + _vm._s(item.ip) + "\n                      ")])]), _vm._v(" "), _c('div', {
	      staticClass: "card-footer"
	    })])
	  })) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "clearfix"
	  })]) : _vm._e()])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-header"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    }
	  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
	    staticClass: "modal-title"
	  }, [_vm._v("Informacije o igraču:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label col-sm-3",
	    attrs: {
	      "for": "skins-cards"
	    }
	  }, [_vm._v("Private skins:")])])
	}]}

/***/ }),
/* 327 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-wrapper"
	  }, [_vm._m(0), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.fb_selected),
	      expression: "fb_selected"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.fb_selected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.fb_users), function(fb, index) {
	    return (fb.id) ? _c('option', {
	      domProps: {
	        "value": index
	      }
	    }, [_vm._v(_vm._s(fb.firstname) + " " + _vm._s(fb.lastname) + " | id: " + _vm._s(fb.id))]) : _vm._e()
	  })), _vm._v(" "), (_vm.fb_selected >= 0) ? _c('div', [_c('h3', [_vm._v("Ovaj korisnik se gasi i menja se sa korisnikom desno:")]), _vm._v(" "), _c('p', [_vm._v("Odabran korisnik: "), _c('a', {
	    attrs: {
	      "href": 'https://facebook.com/' + _vm.fb_users[_vm.fb_selected].facebook_id
	    }
	  }, [_vm._v(_vm._s(_vm.fb_users[_vm.fb_selected].firstname) + " " + _vm._s(_vm.fb_users[_vm.fb_selected].lastname))])]), _vm._v(" "), _c('p', [_vm._v("Godine: " + _vm._s(_vm.fb_users[_vm.fb_selected].age_range))]), _vm._v(" "), _c('p', [_vm._v("Nick: " + _vm._s(_vm.testUri(_vm.fb_users[_vm.fb_selected].nickname)))]), _vm._v(" "), _c('p', [_vm._v("ID: " + _vm._s(_vm.fb_users[_vm.fb_selected].id))])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.fb_selected_2),
	      expression: "fb_selected_2"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.fb_selected_2 = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.fb_users), function(fb, index) {
	    return (fb.id) ? _c('option', {
	      domProps: {
	        "value": index
	      }
	    }, [_vm._v(_vm._s(fb.firstname) + " " + _vm._s(fb.lastname) + " | id: " + _vm._s(fb.id))]) : _vm._e()
	  })), _vm._v(" "), (_vm.fb_selected_2 > 0) ? _c('div', [_c('h3', [_vm._v("Ovaj nalog ostaje:")]), _vm._v(" "), _c('p', [_vm._v("Odabran korisnik: "), _c('a', {
	    attrs: {
	      "href": 'https://facebook.com/' + _vm.fb_users[_vm.fb_selected_2].facebook_id
	    }
	  }, [_vm._v(_vm._s(_vm.fb_users[_vm.fb_selected_2].firstname) + " " + _vm._s(_vm.fb_users[_vm.fb_selected_2].lastname))])]), _vm._v(" "), _c('p', [_vm._v("Godine: " + _vm._s(_vm.fb_users[_vm.fb_selected_2].age_range))]), _vm._v(" "), _c('p', [_vm._v("Nick: " + _vm._s(_vm.testUri(_vm.fb_users[_vm.fb_selected_2].nickname)))]), _vm._v(" "), _c('p', [_vm._v("ID: " + _vm._s(_vm.fb_users[_vm.fb_selected_2].id))])]) : _vm._e()])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-4 col-sm-offset-4"
	  }, [(_vm.fb_selected >= 0 && _vm.fb_selected_2 >= 0) ? _c('button', {
	    staticClass: "btn btn-primary",
	    on: {
	      "click": function($event) {
	        _vm.mergeAccounts()
	      }
	    }
	  }, [_vm._v("Izvrsi zamenu naloga")]) : _vm._e()])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "content-header"
	  }, [_c('h1', [_vm._v("\n      Users\n      "), _c('small', [_vm._v("List of users")])])])
	}]}

/***/ }),
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.ebdcd29a9ec0e08fc6ec.js